import React, { useEffect, useState } from "react";
import {
  getCategorys,
  getCompanys,
  getDepartments,
  getDesignation,
  GetDynamicOptions,
  getEmployee,
  getGroup,
  GetNextVoucherNumber,
  getPayrollDetails,
  GetEmployeewisepayslips,
  getProfitCenter,
  insertEmpPayrollData,
  UpdateVoucherNumber,
  GetEmployeeWisePayslip,
} from "../../services/dataService";
import Breadcrumb from "../../components/common/Breadcrumb";
import { event } from "jquery";
import toast from "react-hot-toast";
import jsPDF from "jspdf";
import auth_bg from "../../assets/images/attukal_bg.jpg";
import "jspdf-autotable";
import autoTable from 'jspdf-autotable';
import { getSecureItem } from "../../services/SecureStorage";

function EmployeeWIesePayslip() {
  const UserName = getSecureItem('UserName');
  const UID = getSecureItem("userId");
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [filterPages, setFilterPages] = useState([])
  const [filterMethod, setFilterMethod] = useState("");
  const [datafilter, setDataFilter] = useState([])
  const [matchedarray,setMatchedArray]=useState([])
  const [salaryOptions, setSalaryOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState("Daily");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [PayrollData, setPayrollData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [additionsDeductions, setAdditionsDeductions] = useState([]);
  const [isAdditionsModalOpen, setAdditionsModalOpen] = useState(false);
  const [isDeductionsModalOpen, setDeductionsModalOpen] = useState(false);

  const [category, setCategory] = useState([])
  const [designation, setdesignation] = useState([])
  const [group, setGroup] = useState([])
  const [Department, setDepartment] = useState([])
  const [FilterProfitcenter, setFilterProfitcenter] = useState([])

  const [deductions, setDeductions] = useState([
    { amount: "", description: "" },
  ]);
  const [addition, setAddition] = useState([
    { additionAmount: "", additionDescription: "" },
  ]);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [employeeId, setEmployeeId] = useState("")
  const [companyDetails, setCompanyDetails] = useState([])
  const fetchCompanyDetails = async () => {
    try {
      const response = await getCompanys(UID);
      setCompanyDetails(response.data.data[0])
      console.log(response.data.data[0], 'Respocsdnse Data');

    } catch (error) {
      console.error('An error occurred:', error);
      toast.error('An error occurred while fetching company details');
    }
  };

  useEffect(() => {
    fetchCompanyDetails()
  }, [])


  useEffect(() => {
    // Get the current date
    const currentDate = new Date();

    // Calculate the first day of the current month
    const firstDay = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      2
    );

    // Calculate the last day of the current month
    const lastDay = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() + 1,
      1
    );

    // Format dates to YYYY-MM-DD
    const formatDate = (date) => date.toISOString().split("T")[0];

    // Set default dates
    setFromDate(formatDate(firstDay));
    setToDate(formatDate(lastDay));
  }, []);


const generateMultipleVouchers = async (payrollDataArray, userId) => {
  try {
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a4",
    });
    const pageWidth = 210; 
    const pageHeight = 297; 
    const voucherWidth = 95;
    const voucherHeight = 95;
    const marginX = 10;
    const marginY = 10;
    const spacingX = 5; // Space between columns
    const spacingY = 5; // Space between rows
    
    function numberToWords(num) {
      const single = [
        "",
        "one",
        "two",
        "three",
        "four",
        "five",
        "six",
        "seven",
        "eight",
        "nine",
      ];
      const teens = [
        "ten",
        "eleven",
        "twelve",
        "thirteen",
        "fourteen",
        "fifteen",
        "sixteen",
        "seventeen",
        "eighteen",
        "nineteen",
      ];
      const tens = [
        "",
        "",
        "twenty",
        "thirty",
        "forty",
        "fifty",
        "sixty",
        "seventy",
        "eighty",
        "ninety",
      ];
      if (num === 0) return "zero";
      function convertLessThanThousand(n) {
        if (n === 0) return "";
        else if (n < 10) return single[n];
        else if (n < 20) return teens[n - 10];
        else if (n < 100)
          return (
            tens[Math.floor(n / 10)] +
            (n % 10 !== 0 ? " " + single[n % 10] : "")
          );
        else
          return (
            single[Math.floor(n / 100)] +
            " hundred" +
            (n % 100 !== 0 ? " " + convertLessThanThousand(n % 100) : "")
          );
      }
      let words = "";
      if (num >= 100000) {
        words += convertLessThanThousand(Math.floor(num / 100000)) + " lakh ";
        num %= 100000;
      }
      if (num >= 1000) {
        words +=
          convertLessThanThousand(Math.floor(num / 1000)) + " thousand ";
        num %= 1000;
      }
      if (num > 0) {
        words += convertLessThanThousand(num);
      }
      return words.trim();
    }
    
    const columns = 2;
    const rows = 3;
    const slipsPerPage = columns * rows;
    const currentDate = new Date();
    const formattedDate = `${currentDate
      .getDate()
      .toString()
      .padStart(2, "0")}/${(currentDate.getMonth() + 1)
      .toString()
      .padStart(2, "0")}/${currentDate.getFullYear().toString().slice(-2)}`;

      const getLastUsedVoucherNumber = async () => {
        try {
          const response = await GetNextVoucherNumber();
          const nextVoucherNo = response?.data?.data?.result?.LastVoucherNo;  // <-- Note the extra .data
          console.log("Voucher No:", nextVoucherNo);
          return nextVoucherNo;
        } catch (error) {
          console.error("Error fetching voucher number:", error);
          return 1;
        }
      };
      
    
      const lastVoucherNumber = await getLastUsedVoucherNumber();
      let currentVoucherNumber = (lastVoucherNumber ?? 0) + 1;
      const usedVoucherNumbers = new Set();
    
    const getUniqueVoucherNumber = () => {
      const prefix = "DV-";
      let paddedNumber, voucherNumber;
      do {
        paddedNumber = currentVoucherNumber.toString().padStart(6, "0");
        voucherNumber = `${prefix}${paddedNumber}`;
        currentVoucherNumber++;
      } while (usedVoucherNumbers.has(voucherNumber));
      usedVoucherNumbers.add(voucherNumber);
      return voucherNumber;
    };
    
    const drawVoucherSlip = (data, x, y, width, height) => {
      const voucherNo = getUniqueVoucherNumber();
      doc.setFillColor(240, 248, 255);
      doc.rect(x, y, width, height, "F");
      doc.setDrawColor(200, 200, 200);
      doc.rect(x, y, width, height, "S");
      const padding = 5;
      const contentX = x + padding;
      const contentWidth = width - padding * 2;
      doc.setFont("helvetica", "bold");
      doc.setFontSize(8);
      doc.setTextColor(0, 51, 102);
      doc.text("DEBIT VOUCHER", x + width / 2, y + 8, { align: "center" });
      doc.setFontSize(6);
      doc.text(
        `${companyDetails.Name.toUpperCase()}`,
        x + width / 2,
        y + 12,
        { align: "center" }
      );
      doc.setFontSize(6);
      doc.setFont("helvetica", "normal");
      doc.text(`Date: ${formattedDate}`, contentX, y + 16);
      doc.text(`Voucher No: ${voucherNo}`, x + width - 30, y + 16);
      doc.text("Head of account:", contentX, y + 20);
      doc.text(data.DepartmentName || "_", contentX + 25, y + 20);
      doc.setFont("helvetica", "bold");
      doc.text("Employee:", contentX, y + 25);
      doc.setFont("helvetica", "normal");
      doc.text(
        `${data.Name} - (${data.Code})` || "Employee",
        contentX + 15,
        y + 25
      );
      doc.text(
        `Position: ${data.DesignationName || "Staff"}`,
        contentX + 50,
        y + 25
      );
      doc.setFont("helvetica", "bold");
      doc.text("Description:", contentX, y + 30);
      doc.setFont("helvetica", "normal");
      doc.text("Days worked:", contentX, y + 35);
      doc.text(
        data?.EmployeeTotalWorkingDays.toString(),
        contentX + 18,
        y + 35
      );
      doc.text("Daily wage:", contentX, y + 40);
      doc.text(
        `Rs. ${data.CurrentBasicPay.toFixed(2)}`,
        contentX + 18,
        y + 40
      );
      doc.text("Net amount:", contentX, y + 45);
      doc.text(`Rs. ${data.NetSalary.toFixed(2)}`, contentX + 18, y + 45);
      doc.setFont("helvetica", "bold");
      doc.text("Amount in words:", contentX, y + 52);
      doc.setFont("helvetica", "normal");
      const amountInWords = numberToWords(Math.floor(data.NetSalary || 0));
      const maxWordLength = 70;
      const displayWords =
        amountInWords.length > maxWordLength
          ? amountInWords.substring(0, maxWordLength) + "..."
          : amountInWords;
      doc.text(`(${displayWords} rupees only)`, contentX, y + 56);
      doc.text("Recipient:", contentX, y + 65);
      doc.line(contentX, y + 68, contentX + 30, y + 68);
      doc.text("Accounts Officer:", contentX + 40, y + 65);
      doc.line(contentX + 40, y + 68, contentX + 70, y + 68);
      doc.text("Treasurer:", contentX, y + 75);
      doc.line(contentX, y + 78, contentX + 30, y + 78);
      doc.text("Secretary:", contentX + 40, y + 75);
      doc.line(contentX + 40, y + 78, contentX + 70, y + 78);
      return voucherNo;
    };
    
    const generatedVoucherNumbers = [];
    const voucherUpdates = []; // Array to store voucher updates for batch API call
    let currentPage = 1;
    
    for (let i = 0; i < payrollDataArray.length; i++) {
      const pageIndex = Math.floor(i / slipsPerPage);
      const positionOnPage = i % slipsPerPage;
      const rowOnPage = Math.floor(positionOnPage / columns);
      const colOnPage = positionOnPage % columns;
      
      if (pageIndex + 1 > currentPage) {
        doc.addPage();
        currentPage++;
      }
      
      const x = marginX + colOnPage * (voucherWidth + spacingX);
      const y = marginY + rowOnPage * (voucherHeight + spacingY);
      const voucherNo = drawVoucherSlip(
        payrollDataArray[i],
        x,
        y,
        voucherWidth,
        voucherHeight
      );
      
      generatedVoucherNumbers.push(voucherNo);
      
      // Prepare voucher update data for API call
      if (payrollDataArray[i].Id) { // Assuming each payroll data has an Id field
        voucherUpdates.push({
          Id: payrollDataArray[i].Id,
          VoucherNo: voucherNo
        });
      }
    }
    
    const totalPages = Math.ceil(payrollDataArray.length / slipsPerPage);
    for (let p = 0; p < totalPages; p++) {
      doc.setPage(p + 1); // Pages are 1-indexed
      doc.setFontSize(8);
      doc.text(
        `Page ${p + 1} of ${totalPages}`,
        pageWidth - 25,
        pageHeight - 10
      );
    }
    
    doc.save("debit_vouchers.pdf");
    
    // Call the UpdateVoucherNumber API to update the database
    try {
      if (voucherUpdates.length > 0) {
        const updatePayload = {
          VoucherUpdates: voucherUpdates,
          UserId: userId // Pass userId as parameter
        };
        
        // Call your API service method
        const updateResponse = await UpdateVoucherNumber(updatePayload);
        console.log("Voucher numbers updated in database:", updateResponse);
      }
    } catch (error) {
      console.error("Error updating voucher numbers in database:", error);
      // You might want to show a warning to the user that PDF was generated but database wasn't updated
    }
    fetchData()
    return {
      success: true,
      message: `Generated ${payrollDataArray.length} voucher(s) across ${totalPages} page(s).`,
      voucherNumbers: generatedVoucherNumbers,
      nextAvailableNumber: currentVoucherNumber,
    };
   
  } catch (error) {
    console.error("Error generating vouchers PDF:", error);
    alert("Failed to generate vouchers PDF. Please try again.");
    return {
      success: false,
      message: error.message,
    };
  }
};
// Individual Employee Voucher Generation Function
const generateIndividualVoucher = async (employeeData, userId) => {
  try {
    const doc = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: 'a4'
    });
    const pageWidth = 210;  // A4 width in mm
    const pageHeight = 297; // A4 height in mm
    const voucherWidth = 180; // Larger width for individual voucher
    const voucherHeight = 140; // Increased height to accommodate all signature fields
    const marginX = 15;
    const marginY = 20;
    
    function numberToWords(num) {
      const single = ['', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
      const teens = ['ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
      const tens = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
      if (num === 0) return 'zero';
      function convertLessThanThousand(n) {
        if (n === 0) return '';
        else if (n < 10) return single[n];
        else if (n < 20) return teens[n - 10];
        else if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 !== 0 ? ' ' + single[n % 10] : '');
        else return single[Math.floor(n / 100)] + ' hundred' + (n % 100 !== 0 ? ' ' + convertLessThanThousand(n % 100) : '');
      }
      let words = '';
      if (num >= 100000) {
        words += convertLessThanThousand(Math.floor(num / 100000)) + ' lakh ';
        num %= 100000;
      }
      if (num >= 1000) {
        words += convertLessThanThousand(Math.floor(num / 1000)) + ' thousand ';
        num %= 1000;
      }
      if (num > 0) {
        words += convertLessThanThousand(num);
      }
      return words.trim();
    }
    
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate().toString().padStart(2, '0')}/${(currentDate.getMonth() + 1).toString().padStart(2, '0')}/${currentDate.getFullYear().toString().slice(-2)}`;
    const startDate = new Date(employeeData?.StartDate);
    const FormattedFromDate = `${startDate.getDate().toString().padStart(2, '0')}/${(startDate.getMonth() + 1).toString().padStart(2, '0')}/${startDate.getFullYear().toString().slice(-2)}`;
    const EndDate = new Date(employeeData?.EndDate);
    const FormattedEndDate = `${EndDate.getDate().toString().padStart(2, '0')}/${(EndDate.getMonth() + 1).toString().padStart(2, '0')}/${EndDate.getFullYear().toString().slice(-2)}`;
    
    const getLastUsedVoucherNumber = async () => {
      try {
        const response = await GetNextVoucherNumber();
        const nextVoucherNo = response?.data?.data?.result?.LastVoucherNo || response?.data?.voucherNo;
        console.log("Voucher No:", nextVoucherNo);
        return nextVoucherNo;
      } catch (error) {
        console.error("Error fetching voucher number:", error);
        return 1;
      }
    };
    
    const lastVoucherNumber = await getLastUsedVoucherNumber();
    let currentVoucherNumber = (lastVoucherNumber ?? 0) + 1;
    const usedVoucherNumbers = new Set();
    
    const getUniqueVoucherNumber = () => {
      const prefix = "DV-";
      let paddedNumber, voucherNumber;
      do {
        paddedNumber = currentVoucherNumber.toString().padStart(6, "0");
        voucherNumber = `${prefix}${paddedNumber}`;
        currentVoucherNumber++;
      } while (usedVoucherNumbers.has(voucherNumber));
      usedVoucherNumbers.add(voucherNumber);
      return voucherNumber;
    };
    
    const drawIndividualVoucher = (data, x, y, width, height) => {
      const voucherNo = getUniqueVoucherNumber();
      
      // Draw voucher background and border
      doc.setFillColor(240, 248, 255);
      doc.rect(x, y, width, height, 'F');
      doc.setDrawColor(0, 51, 102);
      doc.setLineWidth(0.5);
      doc.rect(x, y, width, height, 'S');
      
      const padding = 10;
      const contentX = x + padding;
      const contentWidth = width - (padding * 2);
      
      // Header
      doc.setFont("helvetica", "bold");
      doc.setFontSize(14);
      doc.setTextColor(0, 51, 102);
      doc.text(`DEBIT VOUCHER From ${FormattedFromDate} To ${FormattedEndDate}`, x + (width / 2), y + 15, { align: 'center' });
      
      doc.setFontSize(10);
      doc.text(`${companyDetails.Name.toUpperCase()}`, x + (width / 2), y + 22, { align: 'center' });
      
      // Date and Voucher Number
      doc.setFontSize(9);
      doc.setFont("helvetica", "normal");
      doc.text(`Date: ${formattedDate}`, contentX, y + 35);
      doc.text(`Voucher No: ${voucherNo}`, x + width - 50, y + 35);
      
      // Head of account
      doc.text("Head of account:", contentX, y + 45);
      doc.setFont("helvetica", "bold");
      doc.text(data.DepartmentName || "_", contentX + 35, y + 45);
      
      // Employee Details
      doc.setFont("helvetica", "bold");
      doc.text("Employee Details:", contentX, y + 55);
      doc.setFont("helvetica", "normal");
      doc.text(`Name: ${data.Name || "N/A"}`, contentX, y + 65);
      doc.text(`Code: ${data.Code || "N/A"}`, contentX + 80, y + 65);
      doc.text(`Position: ${data.DesignationName || "Staff"}`, contentX, y + 75);
      
      // Payment Details
      doc.setFont("helvetica", "bold");
      doc.text("Payment Details:", contentX, y + 85);
      doc.setFont("helvetica", "normal");
      doc.text(`Days worked: ${data?.EmployeeTotalWorkingDays || 0}`, contentX, y + 99);
      doc.text(`Daily wage: Rs. ${data.CurrentBasicPay?.toFixed(2) || "0.00"}`, contentX + 60, y + 99);
      
      // Net Amount
      doc.setFont("helvetica", "bold");
      doc.setFontSize(11);
      doc.text(`Net Amount: Rs. ${data.NetSalary?.toFixed(2) || "0.00"}`, contentX, y + 105);
      
      // Amount in words
      doc.setFontSize(9);
      doc.setFont("helvetica", "bold");
      doc.text("Amount in words:", contentX, y + 115);
      doc.setFont("helvetica", "normal");
      const amountInWords = numberToWords(Math.floor(data.NetSalary || 0));
      doc.text(`(${amountInWords} rupees only)`, contentX, y + 129);
      
      // Signature section - Fixed alignment and added missing designations
      const signatureStartY = y + height - 50; // More space for signatures
      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);
      
      // First row of signatures
      const col1X = contentX;
      const col2X = contentX + 60;
      const col3X = contentX + 120;
      
      // Row 1
      doc.text("Recipient:", col1X, signatureStartY);
      doc.line(col1X, signatureStartY + 3, col1X + 45, signatureStartY + 3);
      
      doc.text("Section-in charge:", col2X, signatureStartY);
      doc.line(col2X, signatureStartY + 3, col2X + 45, signatureStartY + 3);
      
      // Row 2 (moved down)
      const row2Y = signatureStartY + 15;
      doc.text("Clerk:", col1X, row2Y);
      doc.line(col1X, row2Y + 3, col1X + 45, row2Y + 3);
      
      doc.text("Sreekaryakar:", col2X, row2Y);
      doc.line(col2X, row2Y + 3, col2X + 45, row2Y + 3);
      
      // Row 3 (moved down further)
      const row3Y = signatureStartY + 30;
      doc.text("Accounts Officer:", col1X, row3Y);
      doc.line(col1X, row3Y + 3, col1X + 45, row3Y + 3);
      
      doc.text("Treasurer:", col2X, row3Y);
      doc.line(col2X, row3Y + 3, col2X + 45, row3Y + 3);
      
      doc.text("Secretary:", col3X, row3Y);
      doc.line(col3X, row3Y + 3, col3X + 45, row3Y + 3);
      
      return voucherNo;
    };
    
    const voucherNumber = drawIndividualVoucher(employeeData, marginX, marginY, voucherWidth, voucherHeight);
    
    const fileName = `voucher_${employeeData.Name?.replace(/[^a-zA-Z0-9]/g, '_') || 'employee'}_${voucherNumber}.pdf`;
    doc.save(fileName);
    
    // Call the UpdateVoucherNumber API to update the database
    try {
      if (employeeData.Id && userId) {
        const updatePayload = {
          Id: employeeData.Id,
          VoucherNo: voucherNumber,
          UserId: userId
        };
        
        // Call your API service method for single update
        const updateResponse = await UpdateVoucherNumber(updatePayload);
        console.log("Voucher number updated in database:", updateResponse);
      }
    } catch (error) {
      console.error("Error updating voucher number in database:", error);
      // You might want to show a warning to the user that PDF was generated but database wasn't updated
    }
    
    fetchData();
    
    return {
      success: true,
      message: `Generated individual voucher for ${employeeData.Name}`,
      voucherNumber: voucherNumber,
      fileName: fileName
    };
  } catch (error) {
    console.error("Error generating individual voucher:", error);
    alert("Failed to generate individual voucher. Please try again.");
    return {
      success: false,
      message: error.message
    };
  }
};

// Function to get employee data and generate voucher
const generateEmployeeVoucher = async (empId) => {
 
    // You'll need to fetch the employee data based on empId
    // This is a placeholder - replace with your actual data fetching logic
    const employeeData = PayrollData.find((emp) => emp.EmpId === empId);
    
    if (employeeData) {
      const result = generateIndividualVoucher(employeeData,UID);
      
    }
   

};

// Placeholder function - replace with your actual data fetching logic
const fetchEmployeePayrollData = async (empId) => {
  // Replace this with your actual API call or data fetching logic
  // This should return the employee's payroll data in the same format as your existing data
  
  // Example return format:
  return {
    EmpId: empId,
    Name: "Employee Name",
    Code: "EMP001",
    DepartmentName: "Department",
    DesignationName: "Position",
    EmployeeTotalWorkingDays: 7,
    CurrentBasicPay: 500.00,
    NetSalary: 3500.00
  };
};
  const fetchData = async () => {
    try {
      const payload = {
        option: selectedOption,
        fromDate,
        toDate,
        UserId: UID, // Ensure UID is passed correctly
      };

      // Call the API function to get payroll details
      const response = await GetEmployeeWisePayslip(payload);
      console.log("Payrolsdsadl Data:", response);
      // Assuming the API returns the data in `response.data`
      setPayrollData(response.data.data[0]);
      setAdditionsDeductions(response.data.data[1]);
 console.log(
  "Filtered EmpId:",
  response.data.data[1]
    .filter(emp => emp.EmpId === "593F8EE0-D61A-4F28-A548-7501A5008A2D")
);


      setSelectedEmployees(new Array(response.data.data[0].length).fill(false));
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleEmployeeCheckboxChange = (index) => {
    const updatedSelectedEmployees = [...selectedEmployees];
    updatedSelectedEmployees[index] = !updatedSelectedEmployees[index];
    setSelectedEmployees(updatedSelectedEmployees);

    // Update "Approve All" checkbox if all are selected
    if (updatedSelectedEmployees.every((isSelected) => isSelected)) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
  };

  const handleSelectAll = () => {
    const newSelectAll = !selectAll;
    setSelectAll(newSelectAll);
    setSelectedEmployees(new Array(PayrollData.length).fill(newSelectAll));
  };

  useEffect(() => {
    console.log("Payrolsdsadl Data:", PayrollData);
  }, [selectedOption]);

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const response = await GetDynamicOptions({
          optionType: "SalaryGenerationOption",
        });
        setSalaryOptions(response.data.data);
      } catch (error) {
        console.error("Error fetching salary options:", error);
      }
    };

    fetchOptions();
  }, []);

  const handleViewClick = () => {
    fetchData();
  };

  const handleAddAddition = () => {
    setAddition([...addition, { additionAmount: "", additionDescription: "" }]);
  };
  const handleAddaddtionChange = (index, field, value) => {
    // Parse value conditionally
    const parsedValue =
      field === "additionAmount" ? parseInt(value, 10) : value;

    // Update additions array
    const updatedAdditions = addition.map((item, i) =>
      i === index ? { ...item, [field]: parsedValue } : item
    );

    // Find the employee with matching employeeId
    const updatedPayrollData = PayrollData.map((employee) => {
      if (employee.EmpId === employeeId) {
        // Calculate difference in addition amount if this is an amount change
        const amountDifference =
          field === "additionAmount"
            ? parsedValue - addition[index].additionAmount
            : 0;

        // Update employee record with new total
        return {
          ...employee,
          TotalAdditions: employee.TotalAdditions + amountDifference,
        };
      }
      return employee;
    });

    // Update both states
    setPayrollData(updatedPayrollData);
    setAddition(updatedAdditions);
  };

  const handleRemoveAddition = (index) => {
    const updatedAdditions = addition.filter((_, i) => i !== index);
    setAddition(updatedAdditions);
  };

  useEffect(() => {
    console.log("addition", addition);
  }, [addition]);

  const handleSaveAddition = () => {
    if (addition.length > 0) {
      // Create the additionData object using the first item in the addition array
      const additionData = {
        BaseAmount: addition[0].additionAmount,
        CalculatedAmount: addition[0].additionAmount,
        ComponentId: "Null",
        ComponentName: addition[0].additionDescription,
        ComponentType: "Addition type",
        EmpId: employeeId,
        PercentageValue: null,
        ValueType: "Fixed Amount",
        WageTypeId: null,
        WageTypeName: null,
      };
      // Update the state 'additionsDeductions' to include this data
      setAdditionsDeductions((prev) => [...prev, additionData]);
      console.log(additionData); // Debugging log
      toggleAdditionsModal(); // Close the modal after saving
      setAddition([]); // Clear the addition state
    } else {
      console.log("No additions to save.");
    }
  };

  //------------------------Deductions----------------

  const handleAddDeduction = () => {
    setDeductions([...deductions, { amount: "", description: "" }]);
  };

  const handleDeductionChange = (index, field, value) => {
    const parsedValue = field === "amount" ? parseInt(value, 10) : value;
    const updatedDeductions = deductions.map((item, i) =>
      i === index ? { ...item, [field]: parsedValue } : item
    );

    const updatedPayrollData = PayrollData.map((employee) => {
      if (employee.EmpId === employeeId) {
        const amountDifferenceDeduct =
          field === "amount" ? parsedValue - deductions[index].amount : 0;

        console.log(amountDifferenceDeduct, "gjgjhgjh");

        return {
          ...employee,
          TotalDeductions: employee.TotalDeductions + amountDifferenceDeduct,
        };
      }
      return employee;
    });
    setPayrollData(updatedPayrollData);
    setDeductions(updatedDeductions);
  };

  const handleRemoveDeduction = (index) => {
    const updatedDeductions = deductions.filter((_, i) => i !== index);
    setDeductions(updatedDeductions);
  };



  const handleSelectChange = (event) => {
    const selectedValue = event.target.value; // Access the selected value correctly
    console.log("Selected Option:", selectedValue);

    setSelectedOption(selectedValue); // Update the state with the selected value
  };

  const toggleAdditionsModal = (Id) => {
    console.log(Id, "ghjkds");

    setEmployeeId(Id);
    setAdditionsModalOpen(!isAdditionsModalOpen);
  };

  const toggleDeductionsModal = (Id) => {
    setEmployeeId(Id);
    setDeductionsModalOpen(!isDeductionsModalOpen);
  };

  useEffect(() => {
    fetchData();
  }, [selectedOption]);
  const handleApprovePayrole = async () => {
    try {
      // Prepare the payload
      const payload = PayrollData.map((employee, index) => {
        const isChecked = selectedEmployees[index] ? 1 : 0; // 1 for checked, 0 for unchecked

        // Filter additions and deductions for the current employee
        const employeeAdditions = additionsDeductions.filter(
          (ad) =>
            ad.EmpId === employee.EmpId && ad.ComponentType === "Addition type"
        );
        const employeeDeductions = additionsDeductions.filter(
          (ad) =>
            ad.EmpId === employee.EmpId && ad.ComponentType === "Deduction type"
        );

        return {
          UserId: UID,
          Id: "",
          VoucherNo: 0,
          employeeId: employee.EmpId,
          isChecked, // Include isChecked in the payload
          selectedOption, // Include selectedOption in the payload
          fromDate, // Include fromDate in the payload
          toDate, // Include toDate in the payload
          ...employee, // Employee data
          additions: employeeAdditions, // Additions data as an array
          deductions: employeeDeductions, // Deductions data as an array
        };
      });

      // Flatten the array structure
      const flatPayload = payload.map((item) => ({
        ...item,
        additions: item.additions || [],
        deductions: item.deductions || [],
      }));

      // Log the payload for debugging
      console.log("Approved Payroll Payload:", flatPayload);

      // Send the payload to the API
      const response = await insertEmpPayrollData(flatPayload);
      console.log("Payroll approved successfully:", response.data);
      if (response.data.message) {
        toast.success("Pay roll Added successfully");
      }
    } catch (error) {
      // Handle errors
      console.error("Error approving payroll:", error);
      toast.error(
        "An error occurred while approving the payroll. Please try again."
      );
    }
  };

  // Install these packages first:
  // npm install jspdf jspdf-autotable

  // Install these packages first:
  // npm install jspdf jspdf-autotable
  const GenerateAllPayslips = () => {
    const date = new Date(fromDate);

    // Use Intl.DateTimeFormat for formatted date string
    const monthNameAndYear = new Intl.DateTimeFormat('en-US', { month: 'long', year: 'numeric' }).format(date);

    // Helper function for proper rounding and formatting
    const formatCurrency = (amount) => {
      // Round to nearest integer
      return Math.round(Number(amount)).toFixed(2);
    };

    // Helper function to safely display text
    const safeText = (value) => value || "N/A";

    // Helper function to convert numbers to words
    const numberToWords = (num) => {
      // Round the number before converting to words
      num = Math.round(num);
      const ones = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
      const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

      if (num === 0) return 'Zero';

      const rupees = Math.floor(num); // Integer part for rupees
      const paise = Math.round((num - rupees) * 100); // Fractional part converted to paise

      const convertToWords = (n) => {
        if (n === 0) return '';
        if (n < 20) return ones[n];
        if (n < 100) {
          return tens[Math.floor(n / 10)] + (n % 10 !== 0 ? ' ' + ones[n % 10] : '');
        }
        if (n < 1000) {
          return ones[Math.floor(n / 100)] + ' Hundred' + (n % 100 !== 0 ? ' and ' + convertToWords(n % 100) : '');
        }
        if (n < 100000) {
          return convertToWords(Math.floor(n / 1000)) + ' Thousand' + (n % 1000 !== 0 ? ' ' + convertToWords(n % 1000) : '');
        }
        if (n < 10000000) {
          return convertToWords(Math.floor(n / 100000)) + ' Lakh' + (n % 100000 !== 0 ? ' ' + convertToWords(n % 100000) : '');
        }
        return convertToWords(Math.floor(n / 10000000)) + ' Crore' + (n % 10000000 !== 0 ? ' ' + convertToWords(n % 10000000) : '');
      };

      let result = convertToWords(rupees);
      if (paise > 0) {
        result += ` and ${convertToWords(paise)} `;
      }
      return result + ' ';
    };


    // Create a new PDF document
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a4"
    });

    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;
    const margin = 5;

    // Calculate dimensions for 10 payslips per page (2 columns × 5 rows)
    const gridWidth = (pageWidth - (margin * 3)) / 2;
    const gridHeight = (pageHeight - (margin * 6)) / 5;

    let currentX = margin;
    let currentY = margin;
    let slipCount = 0;

    filterdPayrollData?.forEach((employee, index) => {
      // Filter additions and deductions for the employee
      const employeeAdditions = additionsDeductions.filter(
        (ad) =>
          ad.EmpId === employee.EmpId &&
          ["Addition type", "Addition"].includes(ad.ComponentType)
      );

      const employeeDeductions = additionsDeductions.filter(
        (ad) =>
          ad.EmpId === employee.EmpId &&
          ["Deduction type", "Deduction"].includes(ad.ComponentType)
      );
      console.log("employeeAdditions", employeeAdditions);

      // Sort the additions to ensure "Basic" appears first
      const sortedAdditions = [...employeeAdditions].sort((a, b) => {
        // Check if component name contains "basic" (case insensitive)
        const aIsBasic = a.ComponentName.toLowerCase().includes("basic");
        const bIsBasic = b.ComponentName.toLowerCase().includes("basic");

        if (aIsBasic && !bIsBasic) return -1; // a comes first
        if (!aIsBasic && bIsBasic) return 1;  // b comes first
        return 0; // keep original order
      });

      const totalAdditions = sortedAdditions.reduce((total, ad) => {
        const amount = ad.ValueType === "Percentage"
          ? (Number(ad.BaseAmount || 0) * Number(ad.PercentageValue || 0)) / 100
          : Number(ad.CalculatedAmount || 0);
        return total + (isNaN(amount) ? 0 : amount);
      }, 0);

      const totalDeductions = employeeDeductions.reduce((total, ded) => {
        const amount = ded.ValueType === "Percentage" && ded.BaseAmount < 15000
          ? (Number(ded.BaseAmount || 0) * Number(ded.PercentageValue || 0)) / 100
          : Number(ded.CalculatedAmount || 0);
        return total + (isNaN(amount) ? 0 : amount);
      }, 0);


      const basicPay = Number(employee.CurrentBasicPay) || 0;
      const workingDays = Number(employee.EmployeeTotalWorkingDays) || 0;
      const grossEarnings = Math.round(totalAdditions);
      const netPay = Math.round(employee?.NetSalary);
      const netPayInWords = numberToWords(netPay) + "";

      // Draw outer border for the payslip
      doc.setLineWidth(0.3);
      doc.rect(currentX, currentY, gridWidth, gridHeight);
      doc.setLineWidth(0.1);

      // Add header with border
      doc.rect(currentX, currentY, gridWidth, 6);

      doc.setFont("helvetica", "bold");
      doc.setFontSize(7);
      doc.text(
        `${companyDetails.Name.toUpperCase()}`,
        currentX + gridWidth / 2,
        currentY + 3,
        { align: "center" }
      );

      // Subtitle
      doc.setFontSize(6);
      doc.text(
        `SALARY SLIP ${monthNameAndYear}`,
        currentX + gridWidth / 2,
        currentY + 5,
        { align: "center" }
      );

      // Employee details section with border
      const detailsSectionHeight = 10;
      doc.rect(currentX, currentY + 6, gridWidth, detailsSectionHeight);

      doc.setFont("helvetica", "normal");
      doc.setFontSize(5);

      // Employee details in compact format
      doc.text(`Name: ${safeText(employee.Name)}`, currentX + 2, currentY + 9);
      doc.text(`Designation: ${safeText(employee.DesignationName)}`, currentX + gridWidth / 2, currentY + 9);
      doc.text(`Department: ${safeText(employee.DepartmentName)}`, currentX + 2, currentY + 12);
      doc.text(`Attendance: ${safeText(workingDays.toString())}`, currentX + gridWidth / 2, currentY + 12);
      doc.text(`Emp_Code: ${safeText(employee.Code)}`, currentX +2, currentY + 15);


      // Earnings and Deductions Table Headers
      const tableY = currentY + 16;
      const columnWidth = gridWidth / 2;

      // Table header borders
      doc.rect(currentX, tableY, columnWidth, 4);
      doc.rect(currentX + columnWidth, tableY, columnWidth, 4);

      // Table headers text
      doc.setFont("helvetica", "bold");
      doc.setFontSize(5);
      doc.text("EARNINGS", currentX + columnWidth / 2, tableY + 2.5, { align: "center" });
      doc.text("DEDUCTIONS", currentX + columnWidth + columnWidth / 2, tableY + 2.5, { align: "center" });

      // Calculate max rows needed but limit to ensure fit
      const maxPossibleRows = 5; // Limiting to 5 rows maximum
      const maxRows = Math.min(
        maxPossibleRows,
        Math.max(sortedAdditions.length, employeeDeductions.length)
      );
      const rowHeight = 3;

      // Draw table cells for items
      for (let i = 0; i < maxRows; i++) {
        const cellY = tableY + 4 + i * rowHeight;

        // Draw cell borders
        doc.rect(currentX, cellY, columnWidth, rowHeight);
        doc.rect(currentX + columnWidth, cellY, columnWidth, rowHeight);

        doc.setFont("helvetica", "normal");
        doc.setFontSize(5);

        // Left side (Earnings) - Using sortedAdditions to display Basic first
        if (i < sortedAdditions.length) {
          const addition = sortedAdditions[i];
          const componentName = addition.ComponentName.length > 12 ?
            addition.ComponentName.substring(0, 10) + ".." :
            addition.ComponentName;

          doc.text(safeText(componentName), currentX + 1, cellY + 2);
          doc.text(
            formatCurrency(addition.CalculatedAmount),
            currentX + columnWidth - 1,
            cellY + 2,
            { align: "right" }
          );
        }

        // Right side (Deductions)
        if (i < employeeDeductions.length) {
          const deduction = employeeDeductions[i];
          const componentName = deduction.ComponentName.length > 12 ?
            deduction.ComponentName.substring(0, 10) + ".." :
            deduction.ComponentName;

          doc.text(safeText(componentName), currentX + columnWidth + 1, cellY + 2);
          doc.text(
            formatCurrency(deduction.CalculatedAmount),
            currentX + gridWidth - 1,
            cellY + 2,
            { align: "right" }
          );
        }
      }

      // Total section
      const totalY = tableY + 4 + maxRows * rowHeight;
      const totalSectionHeight = 6;

      // Draw total section borders
      doc.rect(currentX, totalY, columnWidth, totalSectionHeight);
      doc.rect(currentX + columnWidth, totalY, columnWidth, totalSectionHeight);

      // Draw totals text
      doc.setFont("helvetica", "bold");
      doc.setFontSize(5);
      doc.text("Total:", currentX + 1, totalY + 2);
      doc.text(
        formatCurrency(grossEarnings),
        currentX + columnWidth - 1,
        totalY + 2,
        { align: "right" }
      );

      doc.text("Total:", currentX + columnWidth + 1, totalY + 2);
      doc.text(
        formatCurrency(totalDeductions),
        currentX + gridWidth - 1,
        totalY + 2,
        { align: "right" }
      );

      // Net Pay section
      doc.rect(currentX, totalY + totalSectionHeight, gridWidth, 4);
      doc.setFontSize(5);
      doc.text("NET PAY:", currentX + 1, totalY + totalSectionHeight + 2.5);
      doc.text(
        formatCurrency(netPay),
        currentX + gridWidth - 1,
        totalY + totalSectionHeight + 2.5,
        { align: "right" }
      );

      // Amount in words - truncate if too long
      const wordsY = totalY + totalSectionHeight + 6;
      doc.setFont("helvetica", "italic");
      doc.setFontSize(4);
      const payInWords = netPayInWords.length > 60 ? netPayInWords.substring(0, 60) : netPayInWords;
      doc.text(`Amount in words: ${payInWords} only`, currentX + 1, wordsY,);

      // Signature section
      const signatureY = wordsY + 2;
      // doc.rect(currentX, signatureY, columnWidth, 5);
      // doc.rect(currentX + columnWidth, signatureY, columnWidth, 5);

      doc.setFont("helvetica", "normal");
      doc.setFontSize(4);
      doc.text("Secretary", currentX + columnWidth + columnWidth / 2, signatureY + 4, { align: "center" });

      // Count the slip and move to next position
      slipCount++;

      // Move to next grid cell - different logic for 10 per page (2×5 layout)
      if (slipCount % 2 === 0) {
        // Move to start of next row after every 2 slips
        currentX = margin;
        currentY += gridHeight + margin;
      } else {
        // Move to second column
        currentX += gridWidth + margin;
      }

      // Check if we need a new page
      if (slipCount % 10 === 0) {
        doc.addPage();
        currentX = margin;
        currentY = margin;
      }
    });

    // Download the PDF
    doc.save(`All_Employee_Payslips_${monthNameAndYear}.pdf`);
  };
  const generatePayrollReportpdf = (employeeData, componentData, filterMethod, filterdoption) => {
    console.log(filterMethod, 'dsasdasa', filterdoption);
    const MethodName = (() => {
      if (filterMethod == 'ProfitCenterID') {
        return 'Profitcenter';
      } else if (filterMethod === 'DepartmentID') {
        return 'Department';
      } else if (filterMethod === 'GroupId') {
        return 'Group';
      } else if (filterMethod === 'DesignationId') {
        return 'Designation';
      } else if (filterMethod === 'CategoryId') {
        return 'Category';

      } else {
        return null; // Default value if no conditions are met
      }
    })();
    console.log(MethodName, 'sda');


    const date = new Date(fromDate);

    // Use Intl.DateTimeFormat for formatted date string
    const monthNameAndYear = new Intl.DateTimeFormat('en-US', { month: 'long', year: 'numeric' }).format(date);
    // Create a new jsPDF instance in landscape orientation
    const doc = new jsPDF({
      orientation: 'landscape',
      unit: 'mm',
      format: 'a4'
    });

    // Set document properties
    doc.setProperties({
      title: 'Payroll Detailed Report',
      subject: 'Monthly Payroll Report',
      author: 'Payroll System'
    });

    // Header information
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    // Make text darker
    doc.setTextColor(0, 0, 0);
    doc.text(`${companyDetails.Name.toUpperCase()}`, doc.internal.pageSize.width / 2, 15, { align: 'center' });

    doc.setFontSize(10);
    doc.text(
      `${MethodName 
        ? `${MethodName.toLocaleUpperCase()} WISE DETAILED PAYROLL REPORT FOR ${monthNameAndYear}` 
        : `DETAILED PAYROLL REPORT FOR ${monthNameAndYear}`}`, 
      doc.internal.pageSize.width / 2,
      20,
      { align: 'center' }
    );
    
    doc.text(
      `${MethodName ? `${MethodName.toLocaleUpperCase()}: ${filterdoption}` : ""}`, 
      doc.internal.pageSize.width / 2, 
      25, 
      { align: 'center' }
    );
    
    
    // Print date information
    doc.setFontSize(8);
    doc.setFont('helvetica', 'normal');
    const now = new Date();

    // Format the date as dd/mm/yyyy
    const formattedDate = now.getDate().toString().padStart(2, '0') + '/' +
      (now.getMonth() + 1).toString().padStart(2, '0') + '/' +
      now.getFullYear();

    // Format the time as hh:mm:ss
    const formattedTime = now.toLocaleTimeString('en-GB'); // 'en-GB' ensures 24-hour format

    // Concatenate the formatted date and time
    const formattedDateTime = `${formattedDate} ${formattedTime}`;

    // Print the date and time
    doc.text('PRINT DATE & TIME: ' + formattedDateTime, 15, 35);

    // Current page information
    doc.text('Page 1 of 1', doc.internal.pageSize.width - 20, 20);

    // Helper function to get components for an employee
    function getEmployeeComponents(empId) {
      return componentData.filter(comp => comp.EmpId === empId);
    }

    // Prepare the table data
    const tableData = employeeData.map((emp, index) => {
      // Get component data for calculations if needed
      const empComponents = getEmployeeComponents(emp.EmpId);
      console.log("LICCOM empComponents", empComponents);

      // Calculate HRA, Basic, etc. based on components
      const basicComp = empComponents.find(c => c.WageTypeName?.toLowerCase() === "basic" &&
        c.ComponentName?.toLowerCase() === "basic");
      const hraComp = empComponents.find(c =>
        c.ComponentName?.includes('HRA')
      );

      const spallComponents = empComponents.filter(c =>
        c.ComponentName?.toLowerCase().includes('special allowance') &&
        c.ComponentType === 'Addition'
      );

      const LICCOM = empComponents.filter(c =>
        (c.ComponentName?.includes('LIC') || c.WageTypeName?.includes('LIC')) &&
        c.ComponentType === 'Deduction'
      );
      const SOCLON = empComponents.filter(c =>
        (c.ComponentName?.includes('Society Loan') || c.WageTypeName?.includes('Society Loan')) &&
        c.ComponentType === 'Deduction'
      );

      console.log("LICCOM", LICCOM);



      // Sum their CalculatedAmount
      const spallSum = spallComponents.reduce((sum, c) => sum + (c.CalculatedAmount || 0), 0);

      // Show with 2 decimal points
      const spallTotal = spallSum.toFixed(2);

      const daComp = empComponents.find(c =>
        (c.ComponentName?.replace(/\s/g, '') === 'DA') &&
        c.ComponentType === 'Addition'
      );

      const pfComponents = empComponents.filter(c =>
        (c.ComponentName === 'PF' || c.ComponentName === 'D A') &&
        c.ComponentType === 'Deduction'
      );
      const employeeAdditions = empComponents.filter(
        (ad) =>
          ad.EmpId === emp.EmpId &&
          ["Addition type", "Addition"].includes(ad.ComponentType)
      );

      const employeeDeductions = empComponents.filter(
        (ad) =>
          ad.EmpId === emp.EmpId &&
          ["Deduction type", "Deduction"].includes(ad.ComponentType)
      );

      // --- Correct total addition and deduction calculations ---
      const totalAdditions = employeeAdditions.reduce((total, ad) => {
        const amount = ad.ValueType === "Percentage"
          ? (Number(ad.BaseAmount || 0) * Number(ad.PercentageValue || 0)) / 100
          : Number(ad.CalculatedAmount || 0);
        return total + (isNaN(amount) ? 0 : amount);
      }, 0);

      const totalDeductions = employeeDeductions.reduce((total, ded) => {
        const amount = ded.ValueType === "Percentage" && ded.BaseAmount < 15000
          ? (Number(ded.BaseAmount || 0) * Number(ded.PercentageValue || 0)) / 100
          : Number(ded.CalculatedAmount || 0);
        return total + (isNaN(amount) ? 0 : amount);
      }, 0);

      // Calculate total PF
      const pfSum = pfComponents.reduce((sum, c) => {
        if (c.ValueType === 'Percentage' && c.BaseAmount < 15000) {
          return sum + ((c.BaseAmount || 0) * (parseFloat(c.PercentageValue) || 0) / 100);
        } else if (c.ValueType === 'Percentage' && c.BaseAmount >= 15000) {
          return sum + (c.CalculatedAmount || 0);
        } else if (c.ValueType === 'Nested Percentage') {
          return sum + (c.CalculatedAmount || 0);
        }
        return sum;
      }, 0);
      const totalLIC = LICCOM?.reduce((sum, item) => sum + (item?.CalculatedAmount || 0), 0);
      const TotalSOCLON = SOCLON?.reduce((sum, item) => sum + (item?.CalculatedAmount || 0), 0);

      // Format PF
      const pfTotal = pfSum.toFixed(2);
      // Format data for the table row
      return [
        index + 1,                               // SL NO
        emp.Code,                                // CODE
        emp.Name + '\n' + emp.DesignationName,   // NAME & DESIGNATION
        basicComp ? Math.round(basicComp.CalculatedAmount) : '', // ACTUAL PAY
        basicComp ? Math.round(basicComp.CalculatedAmount) : '', // BASIC
        daComp ? Math.round(daComp.CalculatedAmount) : '',     // DA
        hraComp ? Math.round(hraComp.CalculatedAmount) : '',   // H.R.A
        spallTotal,                              // SPCL ALLOW
        Math.round(totalAdditions)?.toFixed(2),              // TOTAL EARNINGS
        pfTotal,                                 // P.F.
        '',                                      // E.P.F. LOAN
        '',                                      // CANARA LOAN
        '',                                      // SYND HOUSE
                                           // S:MAL ABAR
        '',                                      // DLB
        Math.round(TotalSOCLON) || '',        // ABTT SOC:
        Math.round(totalLIC) || '',           // LIC
       
        '',                                      // EXCES
        '',                                      // RENT
        '',                                      // FINE
        '',                                      // ONAM ADVANCE
        '',                                      // AMBA PRASADAM
        '',                                      // PROFF TAX
        Math.round(totalDeductions)?.toFixed(2),             // TOTAL DEDN.
        Math.round(emp.NetSalary)?.toFixed(2)                 // NET AMT
      ];
    });

    // Define column headers
    const tableHeaders = [
      ['SL.\nNO', 'CODE', 'NAME\nDESIGNATION ', 'ACTUAL\nPAY', 'BASIC', 'DA', 'H.R.A', 'SPCLL.\nALLOW', 'TOTAL\nEARNGS', 'P.F.', 'E.P.F.\nLOAN', 'CANARA\nLOAN', 'SYND\nHOUSE',  'DLB', 'ABTT\nSOC:', 'LIC','EXCES', 'RENT','FINE','ONAM\nADVANCE','AMBA\nPRASADAM','PROFF\nTAX', 'TOTAL\nDEDN.', 'NET AMT.']
    ];

    // Calculate totals for the footer
    const totals = tableData.reduce((acc, row) => {
      // Parse all numerical values safely
      acc.basicPay += parseFloat(row[3]) || 0;         // ACTUALL PAY
      acc.basic += parseFloat(row[4]) || 0;            // BASIC
      acc.da += parseFloat(row[5]) || 0;               // DA
      acc.hra += parseFloat(row[6]) || 0;              // HRA
      acc.spclAllow += parseFloat(row[7]) || 0;        // SPCL ALLOW
      acc.totalEarnings += parseFloat(row[8]) || 0;    // TOTAL EARNINGS
      acc.pf += parseFloat(row[9]) || 0;   
      acc.soc += parseFloat(row[15]) || 0;             // PF
      acc.lic += parseFloat(row[16]) || 0;             // LIC
      acc.totalDeductions += parseFloat(row[22]) || 0; // TOTAL DEDUCTIONS
      acc.netAmount += parseFloat(row[23]) || 0;       // NET AMOUNT
      return acc;
    }, {
      basicPay: 0,
      basic: 0,
      da: 0,
      hra: 0,
      spclAllow: 0,
      totalEarnings: 0,
      soc: 0,
      pf: 0,
      lic: 0,
      totalDeductions: 0,
      netAmount: 0
    });

    // Add footer row - correctly aligned with your table columns
    const footerRow = [
      'PAGE TOTAL:', // SL.NO
      '',            // CODE
      '',            // NAME DESIGNATION & SCALE
      Math.round(totals.basicPay),     // ACTUAL PAY
      Math.round(totals.basic),        // BASIC
      Math.round(totals.da),           // DA
      Math.round(totals.hra),          // H.R.A
      Math.round(totals.spclAllow),    // SPCLL. ALLOW
      Math.round(totals.totalEarnings)?.toFixed(2),// TOTAL EARNGS
      Math.round(totals.pf),           // P.F.
      '',                             // E.P.F. LOAN
      '',                             // CANARA LOAN
      '',                             // SYND HOUSE
                             // S:MAL ABAR
      '',                             // DLB
      Math.round(totals.soc),          // ABTT SOC:
      Math.round(totals.lic),          // LIC
    
      '',                             // EXCES
      '',                             // RENT
      '',                             // FINE
      '',                             // ONAM ADVANCE
      '',                             // AMBA PRASADAM
      '',                             // PROFF TAX
      Math.round(totals.totalDeductions)?.toFixed(2), // TOTAL DEDN.
      Math.round(totals.netAmount)?.toFixed(2)    // NET AMT.
    ];
    
    // Create the table with consistent dark formatting
    // doc.autoTable({
    //   head: tableHeaders,
    //   body: tableData,
    //   foot: [footerRow],
    //   startY: 40,
    //   theme: 'grid',
    //   styles: {
    //     fontSize: 7,
    //     cellPadding: 1,
    //     textColor: [0, 0, 0], // Black text for all cells
    //     lineWidth: 0.1,
    //     lineColor: [0, 0, 0]  // Black border for all cells
    //   },
    //   headStyles: {
    //     fillColor: [255, 255, 255],
    //     textColor: [0, 0, 0],
    //     lineWidth: 0.1,
    //     lineColor: [0, 0, 0],
    //     halign: 'center',
    //     valign: 'middle',
    //     fontStyle: 'bold'
    //   },
    //   bodyStyles: {
    //     lineColor: [0, 0, 0], // Ensure cell borders are black
    //     lineWidth: 0.1       // Same line width as header and footer
    //   },
    //   footStyles: {
    //     fillColor: [255, 255, 255],
    //     textColor: [0, 0, 0],
    //     fontStyle: 'bold',
    //     lineWidth: 0.1,
    //     lineColor: [0, 0, 0]
    //   },
    //   alternateRowStyles: {
    //     fillColor: [255, 255, 255] // Set alternate row background to white
    //   },
    //   columnStyles: {
    //     0: { cellWidth: 8 },  // SL NO
    //     1: { cellWidth: 12 }, // CODE
    //     2: { cellWidth: 30 }, // NAME & DESIGNATION
    //     text: { cellWidth: 'auto' }
    //   },
    //   didDrawPage: function (data) {
    //     // Re-add header if there are multiple pages
    //     if (data.pageCount > 1) {
    //       doc.setFontSize(12);
    //       doc.setFont('helvetica', 'bold');
    //       doc.setTextColor(0, 0, 0); // Ensure black text
    //       doc.text(`${companyDetails.Name.toUpperCase()}`, doc.internal.pageSize.width / 2, 15, { align: 'center' });

    //       doc.setFontSize(10);
    //       doc.text(`DETAILED PAYROLL REPORT FOR ${monthNameAndYear}`, doc.internal.pageSize.width / 2, 20, { align: 'center' });
    //       // doc.text('DEPARTMENT: KUTHIRAM OFFICE', doc.internal.pageSize.width / 2, 25, { align: 'center' });

    //       // Page number
    //       doc.text('Page ' + data.pageCount + ' of ' + doc.internal.getNumberOfPages(), doc.internal.pageSize.width - 20, 20);
    //     }
    //   }
    // });
    doc.autoTable({
      head: tableHeaders,
      body: tableData,
      foot: [footerRow],
      startY: 40,
      theme: 'grid',
      styles: {
        fontSize: 7,
        cellPadding: 1,
        textColor: [0, 0, 0],
        lineWidth: 0.1,
        lineColor: [0, 0, 0]
      },
      headStyles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        lineWidth: 0.1,
        lineColor: [0, 0, 0],
        halign: 'center',
        valign: 'middle',
        fontStyle: 'bold'
      },
      bodyStyles: {
        lineColor: [0, 0, 0],
        lineWidth: 0.1
      },
      footStyles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        fontStyle: 'normal', // Normal for all footer cells by default
        lineWidth: 0.1,
        lineColor: [0, 0, 0]
      },
      alternateRowStyles: {
        fillColor: [255, 255, 255]
      },
      columnStyles: {
        0: { cellWidth: 8 },
        1: { cellWidth: 12 },
        2: { cellWidth: 30 },
        text: { cellWidth: 'auto' }
      },
      didParseCell: function (data) {
        if ( (data.section === 'body' || data.section === 'foot') && (data.column.index === 8 || data.column.index === 22 || data.column.index === 23)) {
          data.cell.styles.fontStyle = 'bold';
        }
      },
      didDrawPage: function (data) {
        if (data.pageCount > 1) {
          doc.setFontSize(12);
          doc.setFont('helvetica', 'bold');
          doc.setTextColor(0, 0, 0);
          doc.text(`${companyDetails.Name.toUpperCase()}`, doc.internal.pageSize.width / 2, 15, { align: 'center' });
    
          doc.setFontSize(10);
          doc.text(`DETAILED PAYROLL REPORT FOR ${monthNameAndYear}`, doc.internal.pageSize.width / 2, 20, { align: 'center' });
          doc.text('Page ' + data.pageCount + ' of ' + doc.internal.getNumberOfPages(), doc.internal.pageSize.width - 20, 20);
        }
      }
    });
    
    // Add signature fields at the bottom
    const finalY = doc.lastAutoTable.finalY + 20;
    doc.setFontSize(8);

    doc.setTextColor(0, 0, 0); // Ensure black text for signatures
    // Spread out all six items evenly
    doc.text('CLERK', 20, finalY, { align: 'center' });
    doc.text('JUNIOR SUPERINTENDENT', 70, finalY, { align: 'center' });
    doc.text('ACCOUNTS OFFICER', 120, finalY, { align: 'center' });
    doc.text('SUPERINTENDENT', 170, finalY, { align: 'center' });
    doc.text('PRESIDENT', 220, finalY, { align: 'center' });
    doc.text('SECRETARY', 270, finalY, { align: 'center' });



    const today = new Date();
    const generatedText = `Generated on: ${today.toLocaleDateString('en-GB')}`;
    const generatedBy = `Generated by: ${UserName}`;

    doc.setFontSize(8);
    doc.setTextColor(0, 0, 0); // Ensure black text
  
    const textWidth = doc.getTextWidth(generatedText);
    const marginRight = 14; // Adjust for padding
    const lineSpacing = 4;  // Adjust for spacing between lines

    // Render the generated text
    doc.text(
      generatedText,
      doc.internal.pageSize.width - textWidth - marginRight,
      doc.internal.pageSize.height - 20
    );

    // Render the generated by text below the generated text
    doc.text(
      generatedBy,
      doc.internal.pageSize.width - textWidth - marginRight,
      doc.internal.pageSize.height - 20 + lineSpacing
    );

    // Save the PDF
    return doc.save(`Payroll_Detailed_Report_${monthNameAndYear}.pdf`);
}
const GeneratePayslip = (employeeId) => {
  // Find all payroll records for the selected employee
  const employeePayrolls = filterdPayrollData.filter((emp) => emp.EmpId === employeeId);

  if (!employeePayrolls || employeePayrolls.length === 0) {
    toast.error("Employee not found!");
    return;
  }

  // Create a new PDF document
  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a4",
  });

  const pageWidth = doc.internal.pageSize.width;
  const pageHeight = doc.internal.pageSize.height;
  const margin = 5;
  const gridWidth = (pageWidth - margin * 3) / 2;
  const minGridHeight = 40;
  const gapBetweenSlips = 3;

  let currentX = margin;
  let currentY = margin;
  let slipCount = 0;
  let leftColumnHeight = 0;
  let rightColumnHeight = 0;

  // Helper function for proper rounding and formatting
  const formatCurrency = (amount) => {
    return Math.round(Number(amount)).toFixed(2);
  };

  // Helper function to safely display text
  const safeText = (value) => value || "N/A";

  // Helper function to convert numbers to words
  const numberToWords = (num) => {
    num = Math.round(num);
    const ones = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
    const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

    if (num === 0) return 'Zero';

    const rupees = Math.floor(num);
    const paise = Math.round((num - rupees) * 100);

    const convertToWords = (n) => {
      if (n === 0) return '';
      if (n < 20) return ones[n];
      if (n < 100) {
        return tens[Math.floor(n / 10)] + (n % 10 !== 0 ? ' ' + ones[n % 10] : '');
      }
      if (n < 1000) {
        return ones[Math.floor(n / 100)] + ' Hundred' + (n % 100 !== 0 ? ' and ' + convertToWords(n % 100) : '');
      }
      if (n < 100000) {
        return convertToWords(Math.floor(n / 1000)) + ' Thousand' + (n % 1000 !== 0 ? ' ' + convertToWords(n % 1000) : '');
      }
      if (n < 10000000) {
        return convertToWords(Math.floor(n / 100000)) + ' Lakh' + (n % 100000 !== 0 ? ' ' + convertToWords(n % 100000) : '');
      }
      return convertToWords(Math.floor(n / 10000000)) + ' Crore' + (n % 10000000 !== 0 ? ' ' + convertToWords(n % 10000000) : '');
    };

    let result = convertToWords(rupees);
    if (paise > 0) {
      result += ` and ${convertToWords(paise)} `;
    }
    return result + ' ';
  };

  // Helper function to wrap text
  const wrapText = (text, maxWidth) => {
    if (!text) return [""];
    const words = text.toString().split(" ");
    if (words.length === 0) return [""];
    const lines = [];
    let currentLine = words[0] || "";
    for (let i = 1; i < words.length; i++) {
      const word = words[i];
      const testLine = currentLine + " " + word;
      const testWidth = doc.getTextWidth(testLine);
      if (testWidth < maxWidth && testLine.length < 50) {
        currentLine = testLine;
      } else {
        lines.push(currentLine);
        currentLine = word;
      }
    }
    lines.push(currentLine);
    return lines.filter((line) => line.trim().length > 0);
  };

  // Iterate over each payroll record for the employee
  employeePayrolls.forEach((employee, index) => {
    const payrollId = employee.Id;
    const date = new Date(employee.StartDate);

    // Format dates based on selectedOption
    let dateHeading, filenameDate;
    if (selectedOption === "Daily") {
      const formattedFromDate = new Intl.DateTimeFormat('en-US', { 
        day: '2-digit', 
        month: 'short', 
        year: 'numeric' 
      }).format(new Date(employee.StartDate));
      
      const formattedToDate = new Intl.DateTimeFormat('en-US', { 
        day: '2-digit', 
        month: 'short', 
        year: 'numeric' 
      }).format(new Date(employee.EndDate));
      
      dateHeading = `SALARY SLIP FROM ${formattedFromDate} TO ${formattedToDate}`;
      filenameDate = `${employee.StartDate.split('T')[0]}_to_${employee.EndDate.split('T')[0]}`;
    } else {
      const monthNameAndYear = new Intl.DateTimeFormat('en-US', { 
        month: 'long', 
        year: 'numeric' 
      }).format(date);
      dateHeading = `SALARY SLIP ${monthNameAndYear}`;
      filenameDate = monthNameAndYear;
    }

    // Filter additions and deductions for the selected employee and payroll
    const employeeAdditions = additionsDeductions.filter(
      (ad) =>
        ad.EmpId === employeeId &&
        ad.PayrollId === payrollId &&
        ["Addition type", "Addition"].includes(ad.ComponentType)
    );

    const sortedAdditions = [...employeeAdditions].sort((a, b) => {
      const aIsBasic = a.ComponentName.toLowerCase().includes("basic");
      const bIsBasic = b.ComponentName.toLowerCase().includes("basic");
      if (aIsBasic && !bIsBasic) return -1;
      if (!aIsBasic && bIsBasic) return 1;
      return 0;
    });

    const employeeDeductions = additionsDeductions.filter(
      (ad) =>
        ad.EmpId === employeeId &&
        ad.PayrollId === payrollId &&
        ["Deduction type", "Deduction"].includes(ad.ComponentType)
    );

    const totalAdditions = sortedAdditions.reduce((total, ad) => {
      const amount = ad.ValueType === "Percentage"
        ? (Number(ad.BaseAmount || 0) * Number(ad.PercentageValue || 0)) / 100
        : Number(ad.CalculatedAmount || 0);
      return total + (isNaN(amount) ? 0 : amount);
    }, 0);

    const totalDeductions = employeeDeductions.reduce((total, ded) => {
      const amount = ded.ValueType === "Percentage" && ded.BaseAmount < 15000
        ? (Number(ded.BaseAmount || 0) * Number(ded.PercentageValue || 0)) / 100
        : Number(ded.CalculatedAmount || 0);
      return total + (isNaN(amount) ? 0 : amount);
    }, 0);

    const workingDays = Number(employee.EmployeeTotalWorkingDays) || 0;
    const grossEarnings = Math.round(totalAdditions);
    const netPay = Math.round(employee.NetSalary);
    const netPayInWords = numberToWords(netPay);

    // Calculate LOP
    const lopValue = Math.max(
      0,
      (employee?.TotalWorkingDays ?? 0) -
        ((employee?.EmployeeTotalWorkingDays ?? 0) +
          (employee?.TotalLeaveDays ?? 0) +
          (employee?.HalfSickLeave ?? 0) +
          (employee?.TotalHalfDay ?? 0) * 2)
    );

    // Calculate dynamic grid height based on content
    const maxRows = Math.max(sortedAdditions.length, employeeDeductions.length, 3);
    const rowHeight = 3;
    const headerHeight = 6;
    const detailsSectionHeight = 20;
    const tableHeaderHeight = 4;
    const totalSectionHeight = 6;
    const netPaySectionHeight = 4;
    const wordsHeight = 4;
    const signatureHeight = 5;
    const gridHeight = Math.max(
      minGridHeight,
      headerHeight +
        detailsSectionHeight +
        tableHeaderHeight +
        maxRows * rowHeight +
        totalSectionHeight +
        netPaySectionHeight +
        wordsHeight +
        signatureHeight +
        2
    );

    // Check if we need a new page
    if (currentY + gridHeight > pageHeight - margin) {
      doc.addPage();
      currentX = margin;
      currentY = margin;
      leftColumnHeight = 0;
      rightColumnHeight = 0;
      slipCount = 0;
    }

    // Draw outer border for the payslip
    doc.setLineWidth(0.3);
    doc.rect(currentX, currentY, gridWidth, gridHeight);
    doc.setLineWidth(0.1);

    // Add header with border
    doc.rect(currentX, currentY, gridWidth, 6);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(7);
    doc.text(
      `${companyDetails?.Name.toUpperCase()}`,
      currentX + gridWidth / 2,
      currentY + 3,
      { align: "center" }
    );

    // Subtitle
    doc.setFontSize(6);
    doc.text(
      dateHeading,
      currentX + gridWidth / 2,
      currentY + 5,
      { align: "center" }
    );

    // Employee details section with border
    doc.rect(currentX, currentY + 6, gridWidth, detailsSectionHeight);

    doc.setFont("helvetica", "normal");
    doc.setFontSize(5);

    // Define two columns
    const col1Width = gridWidth * 0.58;
    const col2Width = gridWidth * 0.38;
    const col1X = currentX + 2;
    const col2X = currentX + col1Width + 4;

    // Starting Y position inside rectangle
    let textY = currentY + 9;
    const lineGap = 1.8;
    const rowGap = 2.0;

    // COLUMN 1: Name, Designation, Department
    let col1Y = textY;
    const nameText = `Name: ${safeText(employee.Name)} (${safeText(employee.Code)})`;
    const nameLines = wrapText(nameText, col1Width - 6);
    nameLines.forEach((line, index) => {
      doc.text(line, col1X, col1Y + index * lineGap);
    });
    col1Y += Math.max(nameLines.length * lineGap, lineGap) + rowGap;

    const designationText = `Desg: ${safeText(employee.DesignationName)}`;
    const designationLines = wrapText(designationText, col1Width - 6);
    designationLines.forEach((line, index) => {
      doc.text(line, col1X, col1Y + index * lineGap);
    });
    col1Y += Math.max(designationLines.length * lineGap, lineGap) + rowGap;

    const departmentText = `Dept: ${safeText(employee.DepartmentName)}`;
    const departmentLines = wrapText(departmentText, col1Width - 6);
    departmentLines.forEach((line, index) => {
      doc.text(line, col1X, col1Y + index * lineGap);
    });

    // COLUMN 2: Attendance and Leave Details
    let col2Y = textY;
    const attendanceText = `Attendance: ${safeText(workingDays.toString())}`;
    doc.text(attendanceText, col2X, col2Y);
    col2Y += lineGap + rowGap;

    const leaveDetailsText = `Deduction: HD:${safeText(employee?.TotalHalfDay)} | SL:${safeText(employee?.HalfSickLeave)} | LC:${safeText(employee?.LateCut)} | LOP:${safeText(lopValue)}`;
    doc.setFontSize(4);
    const leaveLines = wrapText(leaveDetailsText, col2Width - 4);
    leaveLines.forEach((line, index) => {
      doc.text(line, col2X, col2Y + index * 1.5);
    });
    col2Y += Math.max(leaveLines.length * 1.5, 1.5) + rowGap;

    doc.setFontSize(5);
    const leaveTypeText = `Leaves: ${safeText(employee.LeaveTypes)}`;
    const leaveTypeLines = wrapText(leaveTypeText, col2Width - 4);
    leaveTypeLines.forEach((line, index) => {
      doc.text(line, col2X, col2Y + index * lineGap);
    });

    // Earnings and Deductions Table Headers
    const tableY = currentY + 6 + detailsSectionHeight;
    const columnWidth = gridWidth / 2;

    doc.rect(currentX, tableY, columnWidth, 4);
    doc.rect(currentX + columnWidth, tableY, columnWidth, 4);

    doc.setFont("helvetica", "bold");
    doc.setFontSize(5);
    doc.text("EARNINGS", currentX + columnWidth / 2, tableY + 2.5, { align: "center" });
    doc.text("DEDUCTIONS", currentX + columnWidth + columnWidth / 2, tableY + 2.5, { align: "center" });

    // Draw table cells for items
    for (let i = 0; i < maxRows; i++) {
      const cellY = tableY + 4 + i * rowHeight;
      doc.rect(currentX, cellY, columnWidth, rowHeight);
      doc.rect(currentX + columnWidth, cellY, columnWidth, rowHeight);

      doc.setFont("helvetica", "normal");
      doc.setFontSize(5);

      if (i < sortedAdditions.length) {
        const addition = sortedAdditions[i];
        const componentName = addition.ComponentName.length > 15
          ? addition.ComponentName.substring(0, 15) + "..."
          : addition.ComponentName;
        doc.text(safeText(componentName), currentX + 1, cellY + 2);
        doc.text(
          formatCurrency(addition.CalculatedAmount),
          currentX + columnWidth - 1,
          cellY + 2,
          { align: "right" }
        );
      }

      if (i < employeeDeductions.length) {
        const deduction = employeeDeductions[i];
        const componentName = deduction.ComponentName.length > 15
          ? deduction.ComponentName.substring(0, 15) + "..."
          : deduction.ComponentName;
        doc.text(safeText(componentName), currentX + columnWidth + 1, cellY + 2);
        doc.text(
          formatCurrency(deduction.CalculatedAmount),
          currentX + gridWidth - 1,
          cellY + 2,
          { align: "right" }
        );
      }
    }

    // Total section
    const totalY = tableY + 4 + maxRows * rowHeight;
    doc.rect(currentX, totalY, columnWidth, totalSectionHeight);
    doc.rect(currentX + columnWidth, totalY, columnWidth, totalSectionHeight);

    doc.setFont("helvetica", "bold");
    doc.setFontSize(5);
    doc.text("Total:", currentX + 1, totalY + 2);
    doc.text(
      formatCurrency(grossEarnings),
      currentX + columnWidth - 1,
      totalY + 2,
      { align: "right" }
    );
    doc.text("Total:", currentX + columnWidth + 1, totalY + 2);
    doc.text(
      formatCurrency(totalDeductions),
      currentX + gridWidth - 1,
      totalY + 2,
      { align: "right" }
    );

    // Net Pay section
    const netPayY = totalY + totalSectionHeight;
    doc.rect(currentX, netPayY, gridWidth, 4);
    doc.setFontSize(5);
    doc.text("NET PAY:", currentX + 1, netPayY + 2.5);
    doc.text(
      formatCurrency(netPay),
      currentX + gridWidth - 1,
      netPayY + 2.5,
      { align: "right" }
    );

    // Amount in words section
    const wordsY = netPayY + 4;
    doc.rect(currentX, wordsY, gridWidth, 4);
    doc.setFont("helvetica", "italic");
    doc.setFontSize(4);
    const payInWords = netPayInWords.length > 65
      ? netPayInWords.substring(0, 65) + "..."
      : netPayInWords;
    doc.text(`Amount in words: ${payInWords} only`, currentX + 1, wordsY + 2.5);

    // Signature section
    const signatureY = wordsY + 4;
    doc.setFont("helvetica", "normal");
    doc.setFontSize(4);
    doc.text("Secretary", currentX + gridWidth / 2, signatureY + 3, { align: "center" });

    // Update position for next payslip
    slipCount++;
    if (slipCount % 2 === 1) {
      // Left column
      leftColumnHeight = gridHeight;
      currentX += gridWidth + margin; // Move to right column
    } else {
      // Right column
      rightColumnHeight = gridHeight;
      currentX = margin; // Back to left column
      currentY += Math.max(leftColumnHeight, rightColumnHeight) + gapBetweenSlips;
      leftColumnHeight = 0;
      rightColumnHeight = 0;
    }

    // Handle last payslip if odd number
    if (index === employeePayrolls.length - 1 && slipCount % 2 === 1) {
      currentX = margin;
      currentY += leftColumnHeight + gapBetweenSlips;
    }
  });

  // Download the PDF
  doc.save(`Payslips_${safeText(employeePayrolls[0].Name)}_${new Intl.DateTimeFormat('en-US', { month: 'long', year: 'numeric' }).format(new Date())}.pdf`);
};
  
const GenerateVoucher = async (employeeId, userId) => {
  try {
    // Find all payroll records for the selected employee
    const employeePayrolls = filterdPayrollData.filter((emp) => emp.EmpId === employeeId);

    if (!employeePayrolls || employeePayrolls.length === 0) {
      toast.error("Employee not found!");
      return {
        success: false,
        message: "Employee not found!",
      };
    }

    // Create a new PDF document
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a4",
    });

    const pageWidth = 210; // A4 width in mm
    const pageHeight = 297; // A4 height in mm
    const voucherWidth = 95; // Width for each voucher
    const voucherHeight = 67; // Height adjusted for 8 vouchers (4 rows)
    const marginX = 10;
    const marginY = 10;
    const spacingX = 5; // Space between columns
    const spacingY = 5; // Space between rows
    const columns = 2;
    const rows = 4; // 4 rows to fit 8 vouchers
    const slipsPerPage = columns * rows;

    // Function to convert image to base64
    const getBase64Image = (imgUrl) => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "Anonymous";
        img.src = imgUrl;
        img.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);
          const dataURL = canvas.toDataURL("image/png");
          resolve(dataURL);
        };
        img.onerror = (err) => reject(err);
      });
    };

    // Load auth_bg image
    let authBgBase64;
    try {
      authBgBase64 = await getBase64Image(auth_bg);
    } catch (error) {
      console.error("Error loading auth_bg image:", error);
      authBgBase64 = null; // Fallback if image fails to load
    }

    // Number to words function
    function numberToWords(num) {
      const single = [
        "", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine",
      ];
      const teens = [
        "ten", "eleven", "twelve", "thirteen", "fourteen", "fifteen", "sixteen",
        "seventeen", "eighteen", "nineteen",
      ];
      const tens = [
        "", "", "twenty", "thirty", "forty", "fifty", "sixty", "seventy", "eighty", "ninety",
      ];
      if (num === 0) return "zero";
      function convertLessThanThousand(n) {
        if (n === 0) return "";
        else if (n < 10) return single[n];
        else if (n < 20) return teens[n - 10];
        else if (n < 100)
          return (
            tens[Math.floor(n / 10)] +
            (n % 10 !== 0 ? " " + single[n % 10] : "")
          );
        else
          return (
            single[Math.floor(n / 100)] +
            " hundred" +
            (n % 100 !== 0 ? " " + convertLessThanThousand(n % 100) : "")
          );
      }
      let words = "";
      if (num >= 100000) {
        words += convertLessThanThousand(Math.floor(num / 100000)) + " lakh ";
        num %= 100000;
      }
      if (num >= 1000) {
        words += convertLessThanThousand(Math.floor(num / 1000)) + " thousand ";
        num %= 1000;
      }
      if (num > 0) {
        words += convertLessThanThousand(num);
      }
      return words.trim();
    }

    // Date formatting
    const currentDate = new Date();
    const formattedDate = `${currentDate
      .getDate()
      .toString()
      .padStart(2, "0")}/${(currentDate.getMonth() + 1)
      .toString()
      .padStart(2, "0")}/${currentDate.getFullYear().toString().slice(-2)}`;

    // Voucher number handling
    const getLastUsedVoucherNumber = async () => {
      try {
        const response = await GetNextVoucherNumber();
        const nextVoucherNo =
          response?.data?.data?.result?.LastVoucherNo ||
          response?.data?.voucherNo;
        return nextVoucherNo;
      } catch (error) {
        console.error("Error fetching voucher number:", error);
        return 1;
      }
    };

    const lastVoucherNumber = await getLastUsedVoucherNumber();
    let currentVoucherNumber = (lastVoucherNumber ?? 0) + 1;
    const usedVoucherNumbers = new Set();

    const getUniqueVoucherNumber = () => {
      const prefix = "DV-";
      let paddedNumber, voucherNumber;
      do {
        paddedNumber = currentVoucherNumber.toString().padStart(6, "0");
        voucherNumber = `${prefix}${paddedNumber}`;
        currentVoucherNumber++;
      } while (usedVoucherNumbers.has(voucherNumber));
      usedVoucherNumbers.add(voucherNumber);
      return voucherNumber;
    };

    const drawVoucherSlip = (data, x, y, width, height) => {
      const voucherNo = getUniqueVoucherNumber();
      const startDate = new Date(data?.StartDate);
      const FormattedFromDate = `${startDate
        .getDate()
        .toString()
        .padStart(2, "0")}/${(startDate.getMonth() + 1)
        .toString()
        .padStart(2, "0")}/${startDate.getFullYear().toString().slice(-2)}`;
      const EndDate = new Date(data?.EndDate);
      const FormattedEndDate = `${EndDate.getDate()
        .toString()
        .padStart(2, "0")}/${(EndDate.getMonth() + 1)
        .toString()
        .padStart(2, "0")}/${EndDate.getFullYear().toString().slice(-2)}`;

      // Draw voucher background and border
      doc.setFillColor(240, 248, 255);
      doc.rect(x, y, width, height, "F");
      doc.setDrawColor(0, 51, 102);
      doc.setLineWidth(0.5);
      doc.rect(x, y, width, height, "S");

      const padding = 5;
      const contentX = x + padding;
      const contentWidth = width - padding * 2;

      // Add auth_bg icon
      if (authBgBase64) {
        try {
          doc.addImage(authBgBase64, "PNG", contentX, y + 3, 8, 8);
        } catch (error) {
          console.error("Error adding auth_bg image to PDF:", error);
        }
      }

      // Header
      doc.setFont("helvetica", "bold");
      doc.setFontSize(7);
      doc.setTextColor(0, 51, 102);
      doc.text(
        `DEBIT VOUCHER ${FormattedFromDate} - ${FormattedEndDate}`,
        x + width / 2,
        y + 7,
        { align: "center" }
      );
      doc.setFontSize(5);
      doc.text(
        `${companyDetails.Name.toUpperCase()}`,
        x + width / 2,
        y + 10,
        { align: "center" }
      );

      // Date and Voucher Number
      doc.setFontSize(5);
      doc.setFont("helvetica", "normal");
      doc.text(`Date: ${formattedDate}`, contentX, y + 14);
      doc.text(`Voucher No: ${voucherNo}`, x + width - 25, y + 14);

      // Head of account
      doc.text("Head of account:", contentX, y + 18);
      doc.setFont("helvetica", "bold");
      doc.text(data.DepartmentName || "_", contentX + 20, y + 18);

      // Employee Details
      doc.setFont("helvetica", "bold");
      doc.text("Employee Details:", contentX, y + 22);
      doc.setFont("helvetica", "normal");
      doc.text(`Name: ${data.Name || "N/A"}`, contentX, y + 26);
      doc.text(`Code: ${data.Code || "N/A"}`, contentX + 45, y + 26);
      doc.text(
        `Position: ${data.DesignationName || "Staff"}`,
        contentX,
        y + 30
      );

      // Payment Details
      doc.setFont("helvetica", "bold");
      doc.text("Payment Details:", contentX, y + 34);
      doc.setFont("helvetica", "normal");
      doc.text(
        `Days: ${data?.EmployeeTotalWorkingDays || 0}`,
        contentX,
        y + 38
      );
      doc.text(
        `Wage: Rs. ${data.CurrentBasicPay?.toFixed(2) || "0.00"}`,
        contentX + 45,
        y + 38
      );

      // Net Amount
      doc.setFont("helvetica", "bold");
      doc.setFontSize(6);
      doc.text(
        `Net: Rs. ${data.NetSalary?.toFixed(2) || "0.00"}`,
        contentX,
        y + 42
      );

      // Amount in words
      doc.setFontSize(5);
      doc.setFont("helvetica", "bold");
      doc.text("In words:", contentX, y + 46);
      doc.setFont("helvetica", "normal");
      const amountInWords = numberToWords(Math.floor(data.NetSalary || 0));
      const wrappedText = doc.splitTextToSize(
        `(${amountInWords} rupees)`,
        contentWidth - 10
      );
      doc.text(wrappedText, contentX, y + 49);

      // Signature section
      const signatureStartY = y + 54;
      doc.setFont("helvetica", "normal");
      doc.setFontSize(4);

      // Define columns for alignment
      const col1X = contentX;
      const col2X = contentX + 30;
      const col3X = contentX + 60;

      // Row 1
      doc.text("Recipient:", col1X, signatureStartY);
      doc.line(col1X, signatureStartY + 1, col1X + 20, signatureStartY + 1);
      doc.text("Section:", col2X, signatureStartY);
      doc.line(col2X, signatureStartY + 1, col2X + 20, signatureStartY + 1);

      // Row 2
      const row2Y = signatureStartY + 5;
      doc.text("Clerk:", col1X, row2Y);
      doc.line(col1X, row2Y + 1, col1X + 20, row2Y + 1);
      doc.text("Sreekaryakar:", col2X, row2Y);
      doc.line(col2X, row2Y + 1, col2X + 20, row2Y + 1);

      // Row 3
      const row3Y = signatureStartY + 10;
      doc.text("Accounts:", col1X, row3Y);
      doc.line(col1X, row3Y + 1, col1X + 20, row3Y + 1);
      doc.text("Treasurer:", col2X, row3Y);
      doc.line(col2X, row3Y + 1, col2X + 20, row3Y + 1);
      doc.text("Secretary:", col3X, row3Y);
      doc.line(col3X, row3Y + 1, col3X + 20, row3Y + 1);

      return voucherNo;
    };

    const generatedVoucherNumbers = [];
    const voucherUpdates = [];
    let currentPage = 1;

    for (let i = 0; i < employeePayrolls.length; i++) {
      const pageIndex = Math.floor(i / slipsPerPage);
      const positionOnPage = i % slipsPerPage;
      const rowOnPage = Math.floor(positionOnPage / columns);
      const colOnPage = positionOnPage % columns;

      if (pageIndex + 1 > currentPage) {
        doc.addPage();
        currentPage++;
      }

      const x = marginX + colOnPage * (voucherWidth + spacingX);
      const y = marginY + rowOnPage * (voucherHeight + spacingY);
      const voucherNo = drawVoucherSlip(
        employeePayrolls[i],
        x,
        y,
        voucherWidth,
        voucherHeight
      );

      generatedVoucherNumbers.push(voucherNo);

      if (employeePayrolls[i].Id) {
        voucherUpdates.push({
          Id: employeePayrolls[i].Id,
          VoucherNo: voucherNo,
          UserId: userId,
        });
      }
    }

    const totalPages = Math.ceil(employeePayrolls.length / slipsPerPage);
    for (let p = 0; p < totalPages; p++) {
      doc.setPage(p + 1);
      doc.setFontSize(8);
      doc.text(
        `Page ${p + 1} of ${totalPages}`,
        pageWidth - 25,
        pageHeight - 10
      );
    }

    // Save the PDF
    doc.save(`Vouchers_${employeePayrolls[0].Name}_${new Intl.DateTimeFormat('en-US', { month: 'long', year: 'numeric' }).format(new Date())}.pdf`);

    // Update voucher numbers in database
    try {
      if (voucherUpdates.length > 0) {
        const updatePayload = {
          VoucherUpdates: voucherUpdates,
          UserId: userId,
        };
        const updateResponse = await UpdateVoucherNumber(updatePayload);
      }
    } catch (error) {
      console.error("Error updating voucher numbers in database:", error);
    }

    fetchData();

    return {
      success: true,
      message: `Generated ${employeePayrolls.length} voucher(s) across ${totalPages} page(s).`,
      voucherNumbers: generatedVoucherNumbers,
      nextAvailableNumber: currentVoucherNumber,
    };
  } catch (error) {
    console.error("Error generating vouchers PDF:", error);
    toast.error("Failed to generate vouchers PDF. Please try again.");
    return {
      success: false,
      message: error.message,
    };
  }
};

  const handleMonthChange = (e) => {
    const selectedMonth = e.target.value; // e.g., "2025-03"
    const firstDay = `${selectedMonth}-01`;
    const lastDay = new Date(
      selectedMonth.split("-")[0],
      selectedMonth.split("-")[1],
      0
    )
      .toISOString()
      .split("T")[0]; // Last day of the selected month

    setFromDate(firstDay);
    setToDate(lastDay);
  };




  const filterdPayrollData = datafilter?.filter((employe) => {
    if (!searchTerm) return true;
    const term = searchTerm.toLowerCase();
    return (
      employe.Name.toLowerCase().includes(term) ||
      (employe.Code && employe.Code.toLowerCase().includes(term))
    )
  })
  const [selectedFilter, setSelectedFilter] = useState(""); // To store the selected filter
  const [filteredData, setFilteredData] = useState([]);

  const handleFilterPercentageChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedFilter(selectedValue);

    const filtered = PayrollData.filter((data) => {
      const netSalary = data.NetSalary;
      const basicPay = data.CurrentBasicPay;

      if (selectedValue === "above100") {
        return netSalary > basicPay;
      } else if (selectedValue === "below50") {
        return netSalary < 0.5 * basicPay;
      } else if (selectedValue === "below25") {
        return netSalary < 0.25 * basicPay;
      }
      return false;
    });

    setFilteredData(filtered);
  };

  const downloadFilteredDataPDF = (filteredData, selectedFilter) => {
    console.log("filteredData",PayrollData,additionsDeductions);
    
    const date = new Date(fromDate);
  
    // Format month and year
    const monthNameAndYear = new Intl.DateTimeFormat('en-US', {
      month: 'long',
      year: 'numeric'
    }).format(date);
  
    // Create PDF
    const doc = new jsPDF();
   
    // Centered title
    doc.setFontSize(16);
    const title = `Employees Net Salary ${selectedFilter}% Payroll Report for ${monthNameAndYear}`;
    const pageWidth = doc.internal.pageSize.getWidth();
    const titleWidth = doc.getStringUnitWidth(title) * 16 / doc.internal.scaleFactor;
    doc.text(title, (pageWidth - titleWidth) / 2, 20);
  
    // Table columns
    const columns = [
      "Employee Code",
      "Employee Name",
      "Current Basic",
      "Net Salary"
    ];
    
    // Map data rows with required formatting
    const rows = filteredData?.map((item) => [
      item.Code,
      `${item.Name} (${item.Code})`,
      Number(item.CurrentBasicPay).toFixed(2),
      Number(Math.ceil(item.NetSalary)).toFixed(2) // Round up and show .00
    ]);
    
  
    // Generate the table
    doc.autoTable({
      head: [columns],
      body: rows,
      startY: 30,
      theme: 'grid',
      styles: {
        fontSize: 10,
        cellPadding: 2,
        lineWidth: 0.5,
        lineColor: [0, 0, 0], // Black border for all cells
        textColor: [0, 0, 0], // Black text
      },
      headStyles: {
        fillColor: [240, 240, 240],
        textColor: [0, 0, 0],
        lineWidth: 0.8, // Thicker header border
        lineColor: [0, 0, 0]
      },
      bodyStyles: {
        lineColor: [0, 0, 0],
        lineWidth: 0.5
      }
    });
  
    // Save the PDF
    doc.save(`Payroll_Report_${selectedFilter}_${monthNameAndYear}.pdf`);
  };
  

  const clearFilter = () => {
    setSelectedFilter("");
    setFilteredData(PayrollData);
  };



  useEffect(() => {
    setDataFilter(filteredData)
  }, [filteredData])


  useEffect(() => {
    const fetchcategory = async () => {
      try {
        const response = await getCategorys(UID);
        setCategory(response);
        console.log(category, "Filtered Pages");
      } catch (error) {
        console.error("Error fetching cate:", error);
      }
    };
    fetchcategory();
  }, []);


  useEffect(() => {
    const fetchdesignation = async () => {
      try {
        const response = await getDesignation(UID)
        setdesignation(response);
        console.log(designation, "Filtered Pages");
      } catch (error) {
        console.error("Error fetching cate:", error);
      }
    };

    fetchdesignation();
  }, []);



  useEffect(() => {
    const fetchGroup = async () => {
      try {
        const response = await getGroup(UID);

        setGroup(response);
        console.log(group, "Filtered Pages");
      } catch (error) {
        console.error("Error fetching cate:", error);
      }
    };

    fetchGroup();
  }, []);



  useEffect(() => {
    const fetchDepartment = async () => {
      try {
        const response = await getDepartments(UID);

        setDepartment(response);
        console.log(Department, "Filtered Pages");
      } catch (error) {
        console.error("Error fetching cate:", error);
      }
    };

    fetchDepartment();
  }, []);



  useEffect(() => {
    const fetchfilterProfitecenter = async () => {
      try {
        const response = await getProfitCenter(UID);

        setFilterProfitcenter(response);
        console.log(FilterProfitcenter, "Filtered Pages");
      } catch (error) {
        console.error("Error fetching cate:", error);
      }
    };

    fetchfilterProfitecenter();
  }, []);


  useEffect(() => {
    switch (filterMethod) {
      case "CategoryId":
        setDropdownOptions(category?.data?.data);
        break;
      case "ProfitCenterID":
        setDropdownOptions(FilterProfitcenter?.data?.data);
        break;
      case "GroupId":
        setDropdownOptions(group?.data?.data);
        break;

      case "DesignationId":
        setDropdownOptions(designation?.data?.data);
        break;
      case "DepartmentID":
        setDropdownOptions(Department?.data?.data);
        break;
      default:
        setDropdownOptions([]);
        break;
    }
  }, [filterMethod, category, FilterProfitcenter, group, designation, Department]);

  const [filterdoption, setfilterdoption] = useState([])


  const handleFilterChange = (selectedMethod, selectedOptionName) => {
    console.log(selectedMethod, 'Selected Method', selectedOptionName);
    setfilterdoption(selectedOptionName)
    setFilterMethod(selectedMethod);

    // Clone the original PayrollData to start filtering
    let filteredData = [...PayrollData];

    // Apply filtering based on the selected method
    if (selectedMethod === "DepartmentID") {
      filteredData = filteredData?.filter(
        (item) => item.DepartmentName === selectedOptionName
      );
    } else if (selectedMethod === "DesignationId") {
      filteredData = filteredData?.filter(
        (item) => item.DesignationName === selectedOptionName
      );
    } else if (selectedMethod === "ProfitCenterID") {
      filteredData = filteredData?.filter(
        (item) => item.ProfitcenterName === selectedOptionName
      );
    } else if (selectedMethod === "CategoryId") {
      filteredData = filteredData?.filter(
        (item) => item.CategoryName === selectedOptionName
      );
    } else if (selectedMethod === "GroupId") {
      filteredData = filteredData?.filter(
        (item) => item.GroupName === selectedOptionName
      );
    }

    // Update the state with the filtered data
    setDataFilter(filteredData);

    console.log("Filtered Data:", filteredData);
  };


  const handleClearFilter = () => {
    setFilterMethod(""); // Clear the selected filter method
    setDataFilter(PayrollData); // Reset to the original unfiltered data
    console.log("Filters cleared. Showing all data.");
  };


  useEffect(() => {
    setDataFilter(PayrollData)
  }, [PayrollData])


  const ConsoldatedPdf = (filteredPayrollData, fromDate) => {
    // Create new PDF document
    const date = new Date(fromDate);
  
    // Use Intl.DateTimeFormat for formatted date string
    const monthNameAndYear = new Intl.DateTimeFormat('en-US', { month: 'long', year: 'numeric' }).format(date);
    console.log(monthNameAndYear, 'asdasasdasd');
    const doc = new jsPDF();
  
    // Set document properties
    doc.setProperties({
      title: `${companyDetails.Name.toUpperCase()} - Payroll Report`,
      subject: 'Consolidated Employee Report',
      creator: 'Payroll System'
    });
  
    // Define fonts and styles
    doc.setFont('helvetica', 'bold');
  
    // Title and header - centered with minimal spacing
    doc.setFontSize(12);
    const title = `${companyDetails.Name.toUpperCase()}`;
    const titleWidth = doc.getStringUnitWidth(title) * 12 / doc.internal.scaleFactor;
    const pageWidth = doc.internal.pageSize.width;
    doc.text(title, (pageWidth - titleWidth) / 2, 10);
  
    // Subtitle
    doc.setFontSize(11);
    const subtitle = "CONSOLIDATION OF PERMANENT EMPLOYEES";
    const subtitleWidth = doc.getStringUnitWidth(subtitle) * 11 / doc.internal.scaleFactor;
    doc.text(subtitle, (pageWidth - subtitleWidth) / 2, 15);
  
    // Date
    const dateText = `Pay Roll for the Month of ${monthNameAndYear}`;
    const dateWidth = doc.getStringUnitWidth(dateText) * 11 / doc.internal.scaleFactor;
    doc.text(dateText, (pageWidth - dateWidth) / 2, 20);
  
    // Group data by ProfitcenterName
    const groupedData = filteredPayrollData.reduce((acc, item) => {
      if (!acc[item.ProfitcenterName]) acc[item.ProfitcenterName] = [];
      acc[item.ProfitcenterName].push(item);
      return acc;
    }, {});
  
    let startY = 25;
    let grandTotal = 0;
    let pageCount = 1;
  
    // Define column widths and positions - adjusted to accommodate Code column
    const columns = {
      slNo: { x: 10, width: 12 },
      name: { x: 22, width: 65 },
      code: { x: 87, width: 20 },
      designation: { x: 107, width: 50 },
      netAmount: { x: 157, width: 30 }
    };
  
    // Very compact row height
    const rowHeight = 6;
  
    // Function to draw a cell with borders - minimal padding
    const drawCell = (x, y, width, height, text, isHeader = false, isRightAligned = false) => {
      // Draw cell border
      doc.setDrawColor(0);
      doc.setLineWidth(0.1);
      doc.rect(x, y - 4, width, height);
  
      // Set text style
      if (isHeader) {
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(9);
      } else {
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(8);
      }
  
      // Add text with minimal padding
      if (isRightAligned) {
        const textWidth = doc.getStringUnitWidth(text) * (isHeader ? 9 : 8) / doc.internal.scaleFactor;
        doc.text(text, x + width - textWidth - 1, y);
      } else {
        doc.text(text, x + 1, y);
      }
    };
  
    // Function to draw table header
    const drawTableHeader = (y) => {
      drawCell(columns.slNo.x, y, columns.slNo.width, rowHeight, "SL. NO.", true);
      drawCell(columns.name.x, y, columns.name.width, rowHeight, "NAME", true);
      drawCell(columns.code.x, y, columns.code.width, rowHeight, "CODE", true);
      drawCell(columns.designation.x, y, columns.designation.width, rowHeight, "DESIGNATION", true);
      drawCell(columns.netAmount.x, y, columns.netAmount.width, rowHeight, "NET AMOUNT", true);
  
      return y + rowHeight;
    };
  
    // Generate tables for each profit center
    Object.keys(groupedData).forEach((profitCenter) => {
      const data = groupedData[profitCenter];
  
      // Check if we need a new page
      if (startY > doc.internal.pageSize.height - 30) {
        doc.addPage();
        pageCount++;
        startY = 10;
      }
  
      // Section header with profit center name
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(10);
      doc.text(profitCenter, 10, startY);
  
      // Reduced gap between section header and table
      startY += 5;
      startY = drawTableHeader(startY);
  
      // Add table rows
      let profitCenterTotal = 0;
  
      data.forEach((item, index) => {
        // Check if we need a new page
        if (startY > doc.internal.pageSize.height - 15) {
          doc.addPage();
          pageCount++;
          startY = 10;
          startY = drawTableHeader(startY);
        }
  
        // Serial number
        drawCell(columns.slNo.x, startY, columns.slNo.width, rowHeight, (index + 1).toString());
  
        // Name
        drawCell(columns.name.x, startY, columns.name.width, rowHeight, item.Name.toUpperCase());
  
        // Code - assuming the field exists in your data
        drawCell(columns.code.x, startY, columns.code.width, rowHeight, item.Code || '');
  
        // Designation
        drawCell(columns.designation.x, startY, columns.designation.width, rowHeight, item.DesignationName);
  
        // Net Amount (right aligned) - rounded to whole number with two decimal places
        const roundedNetSalary = Math.round(item.NetSalary);
        drawCell(columns.netAmount.x, startY, columns.netAmount.width, rowHeight, roundedNetSalary.toFixed(2), false, true);
  
        profitCenterTotal += item.NetSalary;
        startY += rowHeight; // No extra spacing between rows
      });
  
      // Add profit center total
      grandTotal += profitCenterTotal;
  
      // Total row with spanning cells
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(8);
  
      // Draw total row with merged cells for "TOTAL:" label
      doc.setDrawColor(0);
      doc.setLineWidth(0.1);
      doc.rect(columns.slNo.x, startY - 4, columns.slNo.width + columns.name.width + columns.code.width + columns.designation.width, rowHeight);
      doc.text("TOTAL:", columns.designation.x + 20, startY);
  
      // Draw total amount cell - rounded to whole number with two decimal places
      const roundedProfitCenterTotal = Math.round(profitCenterTotal);
      drawCell(columns.netAmount.x, startY, columns.netAmount.width, rowHeight, roundedProfitCenterTotal.toFixed(2), true, true);
  
      // Minimal spacing between sections
      startY += rowHeight + 2;
    });
  
    // Check if we need a new page for grand total
    if (startY > doc.internal.pageSize.height - 20) {
      doc.addPage();
      pageCount++;
      startY = 15;
    }
  
    // Grand Total row
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(9);
  
    // Draw grand total row with merged cells for "GRAND TOTAL:" label
    doc.setDrawColor(0);
    doc.setLineWidth(0.1);
    doc.rect(columns.slNo.x, startY - 4, columns.slNo.width + columns.name.width + columns.code.width + columns.designation.width, rowHeight);
    doc.text("GRAND TOTAL:", columns.designation.x + 10, startY);
  
    // Draw grand total amount cell - rounded to whole number with two decimal places
    const roundedGrandTotal = Math.round(grandTotal);
    drawCell(columns.netAmount.x, startY, columns.netAmount.width, rowHeight, roundedGrandTotal.toFixed(2), true, true);
  
    // Add signature fields at the bottom with minimal margin
    startY = doc.internal.pageSize.height - 10;
  
    doc.setFontSize(9);
    doc.text("CLERK", 25, startY);
    doc.text("SUPERINTENDENT", 75, startY);
    doc.text("PRESIDENT", 135, startY);
    doc.text("SECRETARY", 180, startY);
  
    // Save PDF
    doc.save(`consolidated_payroll_report ${monthNameAndYear}.pdf`);
  };
  
  const SalaryStatement = (filteredPayrollData, fromDate) => {
    // Create new PDF document
    const date = new Date(fromDate);
  
    // Use Intl.DateTimeFormat for formatted date string
    const monthNameAndYear = new Intl.DateTimeFormat('en-US', { month: 'long', year: 'numeric' }).format(date);
  
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.width;
    const leftMargin = 10;
    const rightMargin = 10;
    const contentWidth = pageWidth - leftMargin - rightMargin;
  
    // Set document properties
    doc.setProperties({
      title: `${companyDetails.Name.toUpperCase()} - Salary Statement`,
      subject: 'Employee Salary Statement',
      creator: 'Payroll System'
    });
  
    // Title with bold font
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(11);
    const title = `${companyDetails.Name.toUpperCase()}`;
    const titleWidth = doc.getStringUnitWidth(title) * 11 / doc.internal.scaleFactor;
    doc.text(title, (pageWidth - titleWidth) / 2, 12);
  
    // // Subtitle 
    // doc.setFontSize(9);
    // const subtitle = `${companyDetails.Address}`;
    // const subtitleWidth = doc.getStringUnitWidth(subtitle) * 9 / doc.internal.scaleFactor;
    // doc.text(subtitle, (pageWidth - subtitleWidth) / 2, 17);
  
    // Date text right after the subtitle
    const dateText = `Salary Statement for the Month of ${monthNameAndYear}`.toUpperCase();
    const dateWidth = doc.getStringUnitWidth(dateText) * 9 / doc.internal.scaleFactor;
    doc.text(dateText, (pageWidth - dateWidth) / 2, 22);
  
    // Single full-width horizontal line after all three headings
    doc.setDrawColor(0);
    doc.setLineWidth(0.5);
    doc.line(leftMargin, 25, pageWidth - rightMargin, 25);
  
    // Reset to normal font weight for body text
    doc.setFont('helvetica', 'normal');
  
    // Add bank details section
    doc.setFontSize(9);
    doc.text("To,", 10, 32);
    doc.text("The Manager,", 10, 37);
    doc.text("Dhanalakshmi Bank", 10, 42);
    // doc.text("Attukal", 10, 47);
  
    doc.text("Sir,", 10, 55);
    doc.text(`Kindly credit the salary of the ${companyDetails.Name} employees as below mentioned.`, 10, 60);
  
    // Calculate total number of pages needed
    const calculateTotalPages = () => {
      // Each page can fit approximately 40 items, plus we need to account for headers and footers
      // Include calculation for table rows plus the total row at the end
      const itemsPerPage = 40;
      return Math.max(1, Math.ceil(filteredPayrollData.length / itemsPerPage));
    };
    
    
    const totalPages = calculateTotalPages();
    
    let startY = 70;
    let pageCount = 1;
    let itemCount = 0;
  
    // Define column widths and positions
    const columns = {
      slNo: { x: 10, width: 15 },
      name: { x: 25, width: 80 },
      accountNo: { x: 105, width: 40 },
      netAmount: { x: 145, width: 45 }
    };
  
    // Row height
    const rowHeight = 6;
  
    // Function to safely format a number with 2 decimal places
    const formatAmount = (value) => {
      // Handle various input types
      let numValue = 0;
  
      if (typeof value === 'number') {
        numValue = value;
      } else if (typeof value === 'string') {
        // Remove commas and try to parse
        numValue = parseFloat(value.replace(/,/g, '')) || 0;
      }
  
      return numValue.toFixed(2);
    };
  
    // Function to draw a table row with or without borders
    const drawRow = (y, slNo, name, accountNo, amount, isHeader = false) => {
      // Set font weight based on whether this is a header row
      doc.setFont('helvetica', isHeader ? 'bold' : 'normal');
  
      // Draw cell borders
      doc.setDrawColor(0);
      doc.setLineWidth(0.1);
      doc.rect(columns.slNo.x, y - 4, columns.slNo.width, rowHeight);
      doc.rect(columns.name.x, y - 4, columns.name.width, rowHeight);
      doc.rect(columns.accountNo.x, y - 4, columns.accountNo.width, rowHeight);
      doc.rect(columns.netAmount.x, y - 4, columns.netAmount.width, rowHeight);
  
      // Add text with appropriate font size
      doc.setFontSize(8);
  
      // SL. NO. column
      if (typeof slNo === 'number') {
        // For numbers, center in the column
        const slNoWidth = doc.getStringUnitWidth(slNo.toString()) * 8 / doc.internal.scaleFactor;
        const slNoX = columns.slNo.x + (columns.slNo.width - slNoWidth) / 2;
        doc.text(slNo.toString(), slNoX, y);
      } else {
        // For header text, left align
        doc.text(slNo.toString(), columns.slNo.x + 1, y);
      }
  
      // Employee name
      doc.text(name, columns.name.x + 1, y);
  
      // Account number
      if (accountNo) {
        doc.text(accountNo, columns.accountNo.x + 1, y);
      }
  
      // Format amount safely for display
      let amountText;
      if (amount === "Net Amount") {
        amountText = amount;
      } else {
        amountText = typeof amount === 'number' || typeof amount === 'string'
          ? formatAmount(amount)
          : "0.00";
      }
  
      // Right align amount
      const amountWidth = doc.getStringUnitWidth(amountText) * 8 / doc.internal.scaleFactor;
      doc.text(amountText, columns.netAmount.x + columns.netAmount.width - amountWidth - 2, y);
    };
  
    // Function to draw table header
    const drawTableHeader = (y) => {
      // Draw the header row with bold text
      drawRow(y, "SL. NO.", "Name", "Account No", "Net Amount", true);
      return y + rowHeight;
    };
  
    // Draw table header
    startY = drawTableHeader(startY);
  
    // Track total amount
    let totalAmount = 0;
  
    // Add data rows
    filteredPayrollData.forEach((item, index) => {
      itemCount++;
  
      // Check if we need a new page
      if (startY > doc.internal.pageSize.height - 20) {
        // Add page number at the bottom
        doc.setFontSize(8);
        doc.text(`Page ${pageCount} of ${totalPages}`, pageWidth / 2, doc.internal.pageSize.height - 10);
  
        // Create new page
        doc.addPage();
        pageCount++;
        startY = 20;
        startY = drawTableHeader(startY);
      }
  
      // Safely parse the amount
      let amount = 0;
      if (typeof item.NetSalary === 'number') {
        amount = item.NetSalary;
      } else if (typeof item.NetSalary === 'string') {
        amount = parseFloat(item.NetSalary.replace(/,/g, '')) || 0;
      }
  
      totalAmount += amount;
  
      // Draw row with employee data (not a header)
      drawRow(
        startY,
        itemCount,
        item.Name ? `${item.Name.toUpperCase()} (${item.Code || ''})` : '',
        item.ACCNO || '',
        Math.round(amount),
        false
      );
  
      startY += rowHeight;
    });
  
    // Check if we need a new page for total
    if (startY > doc.internal.pageSize.height - 25) {
      // Add page number at the bottom
      doc.setFontSize(8);
      doc.text(`Page ${pageCount} of ${totalPages}`, pageWidth / 2, doc.internal.pageSize.height - 10);
  
      // Create new page
      doc.addPage();
      pageCount++;
      startY = 20;
    }
  
    // Add total row with bold text
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(8);
    doc.text("TOTAL:", columns.name.x + 1, startY);
  
    // Draw border for total row
    doc.setDrawColor(0);
    doc.setLineWidth(0.1);
    doc.rect(columns.slNo.x, startY - 4, columns.slNo.width + columns.name.width + columns.accountNo.width, rowHeight);
    doc.rect(columns.netAmount.x, startY - 4, columns.netAmount.width, rowHeight);
  
    // Format and right align total amount
    const roundedTotal = Math.round(totalAmount);
    const totalText = formatAmount(roundedTotal);
    const totalWidth = doc.getStringUnitWidth(totalText) * 8 / doc.internal.scaleFactor;
    doc.text(totalText, columns.netAmount.x + columns.netAmount.width - totalWidth - 2, startY);
  
    // Add "Generated by" information on bottom left
    const today = new Date();
    const generatedText = `Generated on: ${today.toLocaleDateString('en-GB')}`;
    const generatedBy = `Generated by: ${UserName}`;
  
    doc.setFontSize(8);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(0, 0, 0);
    
    // Position "Generated by" information on the bottom left
    doc.text(generatedText, leftMargin, doc.internal.pageSize.height - 20);
    doc.text(generatedBy, leftMargin, doc.internal.pageSize.height - 16);
  
    // Add signature on the bottom right
    doc.setFontSize(9);
    doc.setFont('helvetica', 'bold');
    // Position SECRETARY on the bottom right with proper spacing
    doc.text("SECRETARY", pageWidth - 30, doc.internal.pageSize.height - 20);
  
    // Add page numbering at the bottom center
    doc.setFontSize(8);
    doc.setFont('helvetica', 'normal');
    doc.text(`Page ${pageCount} of ${totalPages}`, pageWidth / 2, doc.internal.pageSize.height - 10);
  
    // Save PDF
    doc.save(`salary_statement_${monthNameAndYear}.pdf`);
  };
  return (
    <>
      {isAdditionsModalOpen && (
        <div
          className="fixed top-0 left-0 w-full h-full  bg-opacity-60 flex justify-center items-center z-50 backdrop-blur-sm"
          onClick={toggleAdditionsModal} // Close modal when clicking outside
        >
          <div
            className="bg-white rounded-lg p-6 w-1/2"
            onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside the modal
          >
            <h2 className="text-xl font-bold mb-4">Additions Details</h2>

            {/* Render Addition Fields */}
            {isAdditionsModalOpen && (
              <div
                className="fixed top-0 left-0 w-full h-full  bg-opacity-30 flex justify-center items-center z-50 backdrop-blur-sm"
                onClick={toggleAdditionsModal} // Close modal when clicking outside
              >
                <div
                  className="bg-white rounded-lg p-6 w-1/2"
                  onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside the modal
                >
                  <h2 className="text-xl font-bold mb-4">Additions Details</h2>

                  {/* Add Addition Button */}
                  <div className="mb-6">
                    <button
                      onClick={handleAddAddition}
                      className="btn btn-secondary"
                    >
                      + Add Another Addition
                    </button>
                  </div>

                  {/* Render Addition Fields */}
                  {isAdditionsModalOpen && (
                    <div
                      className="fixed top-0 left-0 w-full h-full bg-opacity-30 flex justify-center items-center z-50 backdrop-blur-sm"
                      onClick={toggleAdditionsModal} // Close modal when clicking outside
                    >
                      <div
                        className="bg-white rounded-lg p-6 w-1/2 max-h-[80vh] overflow-y-auto"
                        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside the modal
                      >
                        <h2 className="text-xl font-bold mb-4">
                          Additions Details
                        </h2>
                        <div className="space-y-4">
                          {additionsDeductions
                            .filter(
                              (l) =>
                                l.EmpId === employeeId &&
                                (l.ComponentType === "Addition type" ||
                                  l.ComponentType === "Addition")
                            )
                            ?.map((AD) => (
                              <div
                                key={AD.ComponentId}
                                className="p-4 bg-gray-50 rounded-lg shadow-lg border border-gray-300 mb-4"
                              >
                                {/* ComponentName as Main Heading */}
                                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                                  {AD.ComponentName}
                                  <span className="text-sm text-gray-500 ml-1">
                                    (Wage component)
                                  </span>
                                </h3>

                                {/* WageTypeName as Sub-heading */}
                                {AD.WageTypeName && (
                                  <h4 className="text-md text-gray-700 mb-3">
                                    {AD.WageTypeName}
                                    <span className="text-sm text-gray-400 ml-1">
                                      (WageType)
                                    </span>
                                  </h4>
                                )}

                                {/* Amount and Percentage Details */}
                                <div className="space-y-3">
                                  <div className="flex justify-between text-sm">
                                    <span className="text-gray-700">
                                      Base Amount:
                                    </span>
                                    <span className="font-semibold text-gray-900">
                                      {AD.WageTypeId === null || AD.WageTypeId === undefined ? (
                                        <>-</>
                                      ) : (
                                        <>₹{Math.round(AD.BaseAmount)?.toFixed(2)}</>
                                      )}
                                    </span>
                                  </div>

                                  {AD.ValueType === "Percentage" && (
                                    <div className="flex justify-between text-sm">
                                      <span className="text-gray-700">
                                        Percentage:
                                      </span>
                                      <span className="font-semibold text-gray-900">
                                        {AD.PercentageValue}%
                                      </span>
                                    </div>
                                  )}

                                  <div className="flex justify-between text-sm">
                                    <span className="text-gray-700">
                                      Calculated Amount:
                                    </span>
                                    <span className="font-semibold text-gray-900">
                                    {Math.round(AD.CalculatedAmount)?.toFixed(2)}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            ))}

                          {/* Total Additions */}
                          <div className="p-4 bg-white rounded-lg shadow-md border border-gray-200">
                            <div className="flex justify-between text-sm">
                              <span className="text-gray-600 font-semibold">
                                Total Additions:
                              </span>
                              <span className="text-lg font-bold text-gray-900">
                              {Math.round(
    additionsDeductions
      .filter(
        (l) => l.EmpId === employeeId && l.ComponentType === "Addition"
      )
      .reduce((total, AD) => {
        const amount =
          AD.ValueType === "Percentage"
            ? (AD.BaseAmount * AD.PercentageValue) / 100
            : AD.CalculatedAmount;
        return total + amount;
      }, 0)
  ).toFixed(2)}
                              </span>
                            </div>
                          </div>
                        </div>

                        {/* Render Addition Fields */}
                        {/* {addition.length > 0 ? (
                          addition.map((item, index) => (
                            <div
                              key={index}
                              className="mb-4 border-b border-gray-200 pb-4 mt-2"
                            >
                              <label className="block text-sm font-medium">
                                Addition Amount
                              </label>
                              <input
                                type="number"
                                className="border border-gray-300 rounded p-2 w-full mb-2"
                                value={item.additionAmount || ""} // Use default value if undefined
                                onChange={(e) =>
                                  handleAddaddtionChange(
                                    index,
                                    "additionAmount",
                                    e.target.value
                                  )
                                }
                              />

                              <label className="block text-sm font-medium">
                                Addition Description
                              </label>
                              <input
                                type="text"
                                className="border border-gray-300 rounded p-2 w-full"
                                value={item.additionDescription || ""} // Use default value if undefined
                                onChange={(e) =>
                                  handleAddaddtionChange(
                                    index,
                                    "additionDescription",
                                    e.target.value
                                  )
                                }
                              />

                              <button
                                onClick={() => handleRemoveAddition(index)}
                                className="btn btn-danger mt-2"
                              >
                                Remove
                              </button>
                            </div>
                          ))
                        ) : (
                          <p></p>
                        )} */}

                        {/* Add Addition Button */}
                        {/* <div className="mt-6">
                          <button
                            onClick={handleAddAddition}
                            className="btn btn-secondary"
                          >
                            + Add Another Addition
                          </button>
                        </div> */}

                        {/* Save and Cancel Buttons */}
                        <div className="flex justify-end mt-6 space-x-4">
                          <button
                            onClick={toggleAdditionsModal}
                            className="btn btn-primary"
                          >
                            Cancel
                          </button>
                          {/* <button
                            onClick={handleSaveAddition}
                            className="btn btn-success"
                          >
                            Save Additions
                          </button> */}
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Save and Cancel Buttons */}
                  <div className="flex justify-end mt-6 space-x-4">
                    <button
                      onClick={toggleAdditionsModal}
                      className="btn btn-primary"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={handleSaveAddition}
                      className="btn btn-success"
                    >
                      Save Additions
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* Add and Save Buttons */}
            <div className="flex justify-between mt-4">
              <button onClick={handleAddAddition} className="btn btn-secondary">
                + Add Another Addition
              </button>

              <div className="flex justify-end gap-2 mt-4">
                <button
                  onClick={handleSaveAddition}
                  className="btn btn-success"
                >
                  Save Additions
                </button>
              </div>

              <button
                onClick={toggleAdditionsModal}
                className="btn btn-primary"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {isDeductionsModalOpen && (
        <div
          className="fixed top-0 left-0 w-full h-full  bg-opacity-30 flex justify-center items-center z-50 backdrop-blur-sm"
          onClick={toggleDeductionsModal} // Close modal when clicking outside
        >
          <div
            className="bg-white rounded-lg p-6 w-1/2"
            onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside the modal
          >
            <h2 className="text-xl font-bold mb-4">Deductions Details</h2>

            <div
              style={{
                fontFamily: "Arial, sans-serif",
                maxWidth: "100%",
                margin: "20px auto",
                padding: "20px",
                border: "1px solid #ddd",
                borderRadius: "10px",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                backgroundColor: "#fff",
                height: "500px",           // 👈 Set a fixed height
                overflowY: "auto",
              }}
            >
              {/* Header */}
              <h2
                style={{
                  textAlign: "center",
                  color: "#333",
                  marginBottom: "20px",
                }}
              >
                Deductions Receipt
              </h2>

              {/* Deductions List */}
              {additionsDeductions
                .filter(
                  (l) =>
                    l.EmpId === employeeId && l.ComponentType === "Deduction"
                )
                ?.map((AD) => {
                  const isPercentage = AD.ValueType === "Percentage";
                  const calculatedAmount = isPercentage && AD.BaseAmount < 15000
                    ? (AD.BaseAmount * AD.PercentageValue) / 100
                    : AD.CalculatedAmount;

                  return (
                    <div
                      key={AD.ComponentId}
                      style={{
                        marginBottom: "15px",
                        padding: "15px",
                        borderBottom: "1px solid #eee",
                      }}
                    >
                      {/* ComponentName as Main Heading */}
                      <h3 style={{ color: "#444", marginBottom: "10px" }}>
                        {AD.ComponentName}
                      </h3>

                      {/* WageTypeName as Sub-heading */}
                      {AD.WageTypeName && (
                        <h4 style={{ color: "#666", marginBottom: "5px" }}>
                          {AD.WageTypeName}
                        </h4>
                      )}

                      {/* Amount and Percentage Details */}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: "5px",
                        }}
                      >
                        <span style={{ color: "#444" }}>Base Amount:</span>
                        <span style={{ fontWeight: "bold", color: "#444" }}>
                          {AD.WageTypeId === null || AD.WageTypeId === undefined ? (
                            <>-</>
                          ) : (
                            <>₹{AD.BaseAmount}</>
                          )}
                        </span>
                      </div>
                      {isPercentage && (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginBottom: "5px",
                          }}
                        >
                          <span style={{ color: "#444" }}>Percentage:</span>
                          <span style={{ fontWeight: "bold", color: "#444" }}>
                            {AD.PercentageValue}%
                          </span>
                        </div>
                      )}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginTop: "5px",
                        }}
                      >
                        <span style={{ color: "#444" }}>
                          Calculated Amount:
                        </span>
                        <span style={{ fontWeight: "bold", color: "#444" }}>
                          {Math.round(calculatedAmount).toFixed(2)}
                        </span>
                      </div>
                    </div>
                  );
                })}

              {/* Total Deductions */}
              <div className="p-4 bg-white rounded-lg shadow-md border border-gray-200">
                <div className="flex justify-between text-sm">
                  <span className="text-gray-600 font-semibold">
                    Total Deductions:
                  </span>
                  <span className="text-lg font-bold text-gray-900">
  {Math.round(
    additionsDeductions
      .filter(
        (l) =>
          l.EmpId === employeeId &&
          (l.ComponentType === "Deduction type" || l.ComponentType === "Deduction")
      )
      .reduce((total, AD) => {
        const amount =
          AD.ValueType === "Percentage" && AD.BaseAmount < 15000
            ? (AD.BaseAmount * AD.PercentageValue) / 100
            : AD.CalculatedAmount;

        return total + Number(amount);
      }, 0)
  ).toFixed(2)}
</span>

                </div>
              </div>
            </div>

            {/* Render Deduction Inputs */}
            {/* {deductions.length > 0 ? (
              deductions.map((deduction, index) => (
                <div key={index} className="mb-4">
                  <label className="block text-sm font-medium">Amount</label>
                  <input
                    type="number"
                    className="border border-gray-300 rounded p-2 w-full mb-2"
                    value={deduction.amount || ""} // Use default value if undefined
                    onChange={(e) =>
                      handleDeductionChange(index, "amount", e.target.value)
                    }
                  />
                  <label className="block text-sm font-medium">
                    Description
                  </label>
                  <input
                    type="text"
                    className="border border-gray-300 rounded p-2 w-full mb-2"
                    value={deduction.description || ""} // Use default value if undefined
                    onChange={(e) =>
                      handleDeductionChange(
                        index,
                        "description",
                        e.target.value
                      )
                    }
                  />

                  <button
                    onClick={() => handleRemoveDeduction(index)}
                    className="btn btn-danger mt-2"
                  >
                    Remove
                  </button>
                </div>
              ))
            ) : (
              <p></p> // Fallback content when no deductions exist
            )} */}

            {/* Add Deduction Button */}
            {/* <button
              onClick={handleAddDeduction}
              className="btn btn-secondary mt-2"
            >
              + Add Deduction
            </button> */}

            {/* Save and Close Buttons */}
            <div className="flex justify-end gap-2 mt-4">
              {/* <button onClick={handleSave} className="btn btn-success">
                Save
              </button> */}
              <button
                onClick={toggleDeductionsModal}
                className="btn btn-primary"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="p-4">
        <Breadcrumb title="Employee Wise Payslip" />
        <div className="flex flex-col md:flex-row items-center gap-4 w-full mb-4">
          <div className="flex flex-wrap items-center gap-4 w-full">
            {/* Salary Options Dropdown - FIRST */}
            <div className="flex flex-col">
              <label htmlFor="salary-options" className="text-sm mb-1">Salary Option</label>
              <select
                id="salary-options"
                className="border rounded p-2 w-[200px]"
                value={selectedOption}
                onChange={handleSelectChange}
              >
                {salaryOptions.map((option, index) => (
                  <option key={index} value={option.OptionName}>
                    {option.OptionName}
                  </option>
                ))}
              </select>
            </div>

            {/* Month Picker - SECOND */}

            {selectedOption === 'k' ? (
              <div className="flex flex-col">
                <label htmlFor="choose-month" className="text-sm mb-1">Choose Month</label>
                <input
                  type="month"
                  id="choose-month"
                  className="border rounded p-2 w-[200px]"
                  onChange={handleMonthChange}
                />
              </div>
            ) : (
              <div className="flex gap-4 ">
                <div className="flex flex-col">
                  <label htmlFor="from-date" className="text-sm mb-1">From Date</label>
                  <input
                    type="date"
                    id="from-date"
                    className="border rounded p-2 w-[200px]"
                    value={fromDate}
                    onChange={(e) => setFromDate(e.target.value)}
                  />
                </div>
                <div className="flex flex-col">
                  <label htmlFor="to-date" className="text-sm mb-1">To Date</label>
                  <input
                    type="date"
                    id="to-date"
                    className="border rounded p-2 w-[200px]"
                    value={toDate}
                    onChange={(e) => setToDate(e.target.value)}
                  />
                </div>
              </div>
            )}

            {/* View Button - THIRD */}
            <button
              type="button"
              className="btn btn-success mt-6"
              onClick={handleViewClick}
            >
              View
            </button>

            {/* Filter Method Dropdown - FOURTH */}
            <div className="flex flex-col">
              <label htmlFor="filter-method" className="text-sm mb-1">Filter By</label>
              <div className="flex items-center gap-2">
                <select
                  id="filter-method"
                  name="filter-method"
                  className="w-[200px] px-3 py-2 border border-gray-400 rounded-md focus:outline-none focus:ring-0 focus:border-gray-600"
                  value={filterMethod}
                  onChange={(e) => setFilterMethod(e.target.value)}
                >
                  <option value="">Filter By</option>
                  <option value="CategoryId">Category</option>
                  <option value="ProfitCenterID">Profit Center</option>
                  <option value="GroupId">Group</option>
                  <option value="DesignationId">Designation</option>
                  <option value="DepartmentID">Department</option>
                </select>

              </div>
            </div>

            {/* Dynamic Options Dropdown - FIFTH */}
            <div className="flex flex-col">
              <label htmlFor="dynamic-options" className="text-sm mb-1">Choose Option</label>
              <select
                id="dynamic-options"
                name="dynamic-options"
                className="w-[200px] px-3 py-2 border border-gray-400 rounded-md focus:outline-none focus:ring-0 focus:border-gray-600"
                onChange={(e) => {
                  const selectedOption = dropdownOptions?.find(
                    (option) => option.Name?.toString() === e.target.value
                  );
                  if (selectedOption) {
                    handleFilterChange(filterMethod, selectedOption.Name, selectedOption.Name);
                  }
                }}
              >
                <option value="" selected>
                  Choose One
                </option>
                {dropdownOptions?.length > 0 &&
                  dropdownOptions?.map((option) => (
                    <option key={option.Id} value={option.Name}>
                      {option.Name}
                    </option>
                  ))}
              </select>

            </div>
            <button
              onClick={handleClearFilter}
              className="btn btn-danger mt-4"
            >

              Clear
            </button>

            {/* Search Input - LAST */}
            <div className="flex flex-col">
              <label htmlFor="employee-search" className="text-sm mb-1">Search Employees</label>
              <input
                type="search"
                id="employee-search"
                className="border rounded p-2 w-[300px]"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="Search by name or code..."
              />
            </div>
            <div>
             
            </div>
          </div>
        </div>
        

        <div>
        <table className="table-auto w-full border-collapse border border-gray-200">
  <thead>
    <tr className="bg-gray-100">
      <th className="border border-gray-300 px-4 py-2">Sl No</th>
      <th className="border border-gray-300 px-4 py-2">Employee Name</th>
      <th className="border border-gray-300 px-4 py-2">No. of Payslips</th>
      <th className="border border-gray-300 px-4 py-2">Download Payslip</th>
    </tr>
  </thead>
  <tbody>
    {filterdPayrollData.length > 0 ? (
     filterdPayrollData
     .filter((employee, index, self) =>
       index === self.findIndex((e) => e.EmpId === employee.EmpId)
     )
     .map((employee, index) => {
       const payslipCount = PayrollData.filter(
         (e) => e.EmpId === employee.EmpId
       ).length;

        return (
          <tr key={index}>
            <td className="border border-gray-300 px-4 py-2">{index + 1}</td>
            <td className="border border-gray-300 px-4 py-2">
              {employee.Name} ({employee.Code})
            </td>
            <td className="border border-gray-300 px-4 py-2">{payslipCount}</td>
            <td className="border border-gray-300 px-4 py-2">
  {(selectedOption === "Monthly" || selectedOption === "Daily") ? (
  <>
    {console.log(selectedOption, "dsdsd")}
    <button
      onClick={() => GeneratePayslip(employee.EmpId)}
      className="btn btn-success"
    >
      DownloadPayslip
    </button>
  </>
) : (
  <button
    onClick={() => GenerateVoucher(employee.EmpId)}
    className="btn btn-success"
  >
    Download Voucher
  </button>
)}

</td>

          </tr>
        );
      })
    ) : (
      <tr>
        <td
          colSpan="4"
          className="border border-gray-300 px-4 py-2 text-center"
        >
          No data available
        </td>
      </tr>
    )}
  </tbody>
</table>

          {/* <button
            onClick={handleApprovePayrole}
            className="btn btn-success mt-3 flex-end "
          >
            Approve Payrole
          </button> */}
        </div>
      </div>
    </>
  );
}





export default EmployeeWIesePayslip